module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_c('h2', {
    staticClass: "ch_num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap_head"
  }, [_vm._v("The Fundamentals of a Formation")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he point and purpose of a formation is twofold: to induce and permit a collection of individuals to operate as a unit of soldiers and to allow each man to make an effective contribution for minimal outlay of energy. A formation achieves this by conferring orientation, familiarity and security on its component individuals and by maximising the damage-producing front presented to the enemy while minimising the damage-vulnerable aspect of each individual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Essential qualities of the formation are: 1) the ability of its men to move together without haste, delay or confusion; 2) the effective concentration of a unit’s weaponry on its forward aspect; 3) maximising the effective protection of its men; and 4) providing sufficient basis for confidence to keep the men facing the enemy and fighting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Practically the only detailed information we have on the military formations of Antiquity comes from four sources: the Hellenistic tactical manuals of Asklepiodotus, Aelian and Arrian, and the Roman manual of Vegetius (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(" of Kauţilya gives useful additional information on chariots).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Asklepiodotus is the earliest of the three Hellenists. It is generally supposed that he was a pupil of the philosopher Poseidonios (Ca. 135– 50 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), whom he used as the source for his manual. Poseidonios was a Macedonian who lived in the Seleucid Empire, and Asklepiodotus’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ars Tactica")]), _vm._v(" describes the Seleucid military system, itself an amalgam of Macedonian and Persian military doctrine, evident from the reference to elephants and chariots along with detailed descriptions of the structure of the Macedonian phalanx.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_vm._v("Next in order of time is Aelian. His tactical manual was dedicated to the Emperor Hadrian (117–138 ad) though initially begun for Trajan. Aelian gives a list of sources he used to compile his manual among ")]), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_vm._v("which the name of Asklepiodotus is conspicuous by its absence. The similarities between the two manuals makes it evident Aelian drew from Asklepiodotus, but since Asklepiodotus himself drew from Poseidonios whom Aelian cites as a source, it is possible Aelian viewed Asklepiodotus’ manual as essentially Poseidonios’ own work.")])]), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Arrian, probably born in Nicomedia between 85 and 92 ad, was a contemporary of Aelian. He had a brilliant military and political career as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legatus Augusti pro praetore")]), _vm._v(" of Cappadocia. In 135 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" he had the responsibility of repulsing a threat by Sarmatian Alans and prepared a plan for his army of which the text survives, but there is no proof a battle actually took place. The following year he wrote his manual, probably to commemorate the 20th year anniversary of Hadrian’s reign. His work reproduces and paraphrases parts of Aelian’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These three authors are not copies of each other, but together give a clear and fairly coherent picture of how infantry and cavalry units were organised and structured, and how they adopted different formations best suited to different situations and needs. Strictly speaking they apply to the Seleucid and to a lesser extent the Roman army, but the principles they contain were equally relevant to any organised army that preceded the invention of gunpowder – and even, in many respects, to armies for centuries afterwards. The three tacticians divide an army into the following categories:")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("1.")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Infantry")]), _vm._v(", which subdivides into heavy infantry, light skirmisher foot and peltasts. Heavy infantry is infantry that is equipped essentially for hand-to-hand fighting. Light skirmisher infantry usually had no shields or protective armour, and was equipped with ranged weapons like slings, javelins and bows. They were meant to engage enemy from a distance, and flee if charged. Peltasts were an intermediate type, equipped with javelins as their primary weapon but also possessing swords and a shield but no body armour. They could engage light and intermediate cavalry and could outfight light foot. Against heavy foot they limited themselves to ranged missile attacks, fleeing if charged.")])]), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cavalry")]), _vm._v(", which subdivides into armoured heavy cavalry, light skirmisher cavalry, and lanceor javelin-armed intermediate ")]), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_vm._v("cavalry. Armoured heavy cavalry were cataphracts, with both horse and rider covered in protective armour, and capable of engaging heavy infantry in hand-to-hand combat. Light skirmisher cavalry were unarmoured and used ranged weapons like javelins and bows as their primary weapon. They would limit themselves to ranged combat, evading if charged. Intermediate cavalry came in different kinds, and could be armed with javelins and lances, capable of both ranged combat and charging into contact with enemy, but not meant to fight heavy infantry in a static melee.")])]), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Elephants")]), _vm._v(" used for war were of two kinds, the Indian, distinguishable by its smaller ears and different head configuration, and the African. While a few African savannah elephants were fielded by the Ptolemaic army at Raphia in 217 bc, the bulk of African elephants were those of a smaller breed more easily obtained, trained and transported. The relative docility and tractability of this smaller species was important for transportation by sea, often a major consideration for Ptolemies and Carthaginians alike.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("The typical war elephant took years to train, and was trained to seize, tusk and trample opponents. Indian elephants were also taught to throw a man seized by the trunk, but Hellenistic armies considered this to be superfluous.")])]), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_vm._v("Elephants were very hard to kill. Alexander’s army at the Hydaspes fought against Porus’ elephants for much of the day, seriously wounded many of them, but there is no indication that they managed to kill a single one until the battle was effectively over.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn1",
      "id": "ch1_1"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])]), _vm._v(" Similarly, there is no mention of elephants being killed at Zama in 202 bc, and in battles like the Metaurus, where the Carthaginian army was wiped out, about half the elephants survived, those slain having been killed by their drivers when they stampeded. Elephants could nevertheless be wounded and the pain of wounds could send them into an uncontrollable frenzy. One rampaging elephant sufficed to put a stop to Pyrrhus’ pursuit of the Romans at Heraclea in 280 bc. In order to protect elephants against being wounded, they were often given protective drapes and housings and sometimes full metal armour. Armoured or otherwise, they were always most vulnerable from the rear, and for this reason were often accompanied by light "), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_vm._v("infantry whose task was to support them and to prevent opponents working round to the elephants’ more vulnerable sides and back.")])]), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('p', {
    staticClass: "hanging"
  }, [_vm._v("Elephants carried a fighting crew of two to four men (sometimes more), often housed in a tower or howdah carried on the elephant’s back. These would be armed with bows and/or javelins; in Hellenistic armies one crewman might carry a pike as a final means of discouraging enemies who were attempting to hamstring the elephant or stab its sensitive rear area. In combat, the elephant would do most of the killing, trampling down opponents by main force while seizing occasional men with its trunk or trying to put a tusk through them. Elephants were also useful for breaking down gates of fortified camps and cities.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("4.")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chariots")]), _vm._v(" were predominantly of the two-wheeled, twoto fourhorse variety. The chariot was the premier weapon of the biblical era, a kingdom’s strength often being measured in chariots. Chariot crews were the most highly-trained of their nation’s armed forces, and were usually kept on permanent establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("All chariots had a driver, and although it was possible to be a driver-warrior, some Pharaohs being depicted crewing their chariot alone, with the reins about their waist for managing the horses and thus leaving their arms free to use a bow, the typical chariot had a fighting crewman who was usually a javelinman or an archer, while some had an additional shieldbearer or shieldbearers.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Chariots, like elephants, were intended primarily as formationbreakers, but unlike elephants, which tended to apply themselves to the periphery of the opposing formation and gradually break their way through it, chariots customarily undertook to break the enemy formation with a single decisive charge. The charge would be decisive only if the enemy being charged lacked sufficient resilience and depth to stand against the chariotry, so chariots were reliant upon their foes being either apprehensive or demoralised. Chariotry was customarily used in massed formations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Following these categories, I will use the Hellenistic manuals as a guideline in understanding the fundamental characteristics of a formation, be it foot, mounted or elephant. Vegetius will be used to round out the picture. Let me start with heavy infantry.")])]), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2. Heavy Infantry – Organisation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The list of formations given above contains diverse troop types that worked in very different ways, nevertheless it is possible to pick out general principles that governed how a formation moved and fought and in consequence how it was structured.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_vm._v("When a body of men come together to fight hand-to-hand – which was the proper mode of combat for heavy foot – the two groups tend to flatten out into two lines with little or no intermingling. One sees this in battles between Russian football supporters (where the police are often conspicuous by their absence). A good example can be seen here: "), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=g-GplRfIq6A",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=g-GplRfIq6A")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is natural. A human being who fights another human being fights in one direction – to his front – and as part of a crowd he will want his two sides and rear protected, which is best achieved by forming a line. He will also want to fight at odds no worse than one-to-one, also taken care of by forming a line.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The file")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A line is hardly a formation as such, just the natural result of two groups of men who collide in combat. What is characteristic of infantry formations and square mounted formations is the use of "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("files")]), _vm._v(" to form a line. Files were initially the smallest combat units on the battlefield and are described in some detail in the manuals. They generally varied in size from eight to sixteen men:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is necessary, first of all, to divide the phalanx, that is, to break it up into files. Now a file is a number of men dividing the phalanx into symmetrical units, and by ‘symmetrical’ I mean those which do not interfere with the fighting efficiency of the phalanx. Accordingly some have formed the file of eight men, others of ten, others of twelve, and yet others of sixteen men – Asklepiodotus: 2 (cf. Aelian: 4)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Some make the number of the file ten, others add two to the ten, some even make it sixteen. Let our deepest one be at sixteen. The latter is proportionate to the formation’s length, the phalanx’s depth, both for shooting arrows and for throwing spears from the "), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }, [_vm._v("lightly armed of those standing in formation. If it is necessary to double the depth to thirty-two men, the formation will [still] be proportionate. If the length is set at eight in front, the phalanx will not be entirely depthless. But if you wish to extend the phalanx at eight to four, it becomes depthless. – Arrian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 5")])]), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }, [_vm._v("Each file was composed of a file leader ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lochagos")]), _vm._v(" in Asklepiodotus")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn2",
      "id": "ch1_2"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(") who was the first man in the file and the one who did the actual fighting. Behind came the other members of the file with the file-closer ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ouragos")]), _vm._v(") – the file leader’s second in command – at the end, whose job was to ensure the file remained straight and prevent any of the troops in the file from taking the option of early military retirement (see Diagram 1).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_26-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 1: The file, showing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lochagos")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ouragos")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each individual soldier of a file was also either a ‘front-man’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protostates")]), _vm._v(" in Asklepiodotus) or a ‘back-man’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistates")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn3",
      "id": "ch1_3"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])]), _vm._v(" The file leader would be the first front-man, the man behind him a back-man, the third man in the file a front-man, the fourth man a back-man, and so on, to the last man of the file, the file-closer, who was always a back-man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially a file was the most basic unit in an infantry formation, but later on it was split into half-files ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hemilochion")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dimoiria")]), _vm._v(") and finally quarter-files ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enomotia")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn4",
      "id": "ch1_4"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])]), _vm._v(" These half and quarter divisions were necessary to enable the formation to perform the manoeuvre known as doubling (see below) and, possibly, to facilitate marching in column.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Line")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Files were placed side-by-side to create a complete line with uniform depth, the file leaders adjacent to each other to form a continuous front:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now when one file is placed beside another, so that file-leader stands beside file-leader, file-closer beside file-closer, and the men in between beside their comrades-in-rank ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homozygoi")]), _vm._v("], such an "), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_vm._v("arrangement will be a formation by file ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("syllochismos")]), _vm._v("], and the men of the files forming the same rank, front rank men, and rear rank men, will be called comrades-in-rank because they stand side by side. – Asklepiodotus: 2.4")])]), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_vm._v("According to the manuals a complete line of heavy infantry consisted of 1,024 files each with 16 men forming the three tacticians’ ideal phalanx of 16,384 men.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn5",
      "id": "ch1_5"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" 1024 is chosen as the number of files because it is divisible by 2 all the way down to 1. Each half-division was a distinct sub-formation with a separate name and a separate commander, at least in theory. This enabled the general to create a unit of any size composed of an appropriate number of sub-formations, or, if he preferred, to choose, for ease of control, the sub-formation that most suited his needs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why a line 1,024 files wide? Wider lines were possible and indeed used on occasion, but one sees here an interesting correlation between Macedonian and Roman infantry lines. The Republican Roman Consular army of four legions arranged in three lines of Hastati, Principes and Triarii had a similar width. Each legion deployed 200 yards wide giving a total frontage of 800 yards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only intact Roman version we have of a military manual in Antiquity is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(", composed at the end of the 4th century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" or early in the 5th. Its author, Publius Flavius Vegetius Renatus, appeals for a reform of the Roman army along the lines of its excellence – or as Vegetius imagined its excellence – in the early imperial period. His book has a number of anachronisms, for example attributing the use of plumbati to Republican infantry, nonetheless his elements of Roman army organisation, tactics and weaponry are accurate enough once put in the right chronological place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Vegetius, a line of infantry should be no wider than 1,656 yards wide with one yard per file:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("One thousand paces contain a single rank of one thousand six hundred and fifty-six foot soldiers, each man being allowed three feet. Six ranks drawn up on the same extent of ground will require nine thousand nine hundred and ninety-six men. To form only three ranks of the same number will take up two thousand paces, "), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_vm._v("but it is much better to increase the number of ranks than to make your front too extensive. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(": 3")])]), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A Roman pace was about 1.48 metres or 4 feet 10 inches (the Roman foot being slightly shorter than an English foot). Each file would then have slightly less than three feet but near enough as no matter. For Vegetius, a frontage of 1,656 yards was preferable for an army of 10,000, 20,000 or 30,000 men, the larger army deploying in greater depth rather than in too wide a frontage:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("But if the field of battle is not spacious enough or your troops are very numerous, you may form them into nine ranks or even more, for it is more advantageous to engage in close order than to extend your line too much. An army that takes up too much ground in front and too little in depth, is quickly penetrated by the enemy’s first onset. After this there is no remedy. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ibid")]), _vm._v(".")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_vm._v("This is a description of a late Roman army deployed in a single line. It would seem that this was about the limit that infantry could deploy and still manoeuvre as a single body under the control of the general, probably because visual or vocal commands could not be perceived at a greater distance. An order to advance would be understood by one section of the army but not by the other that was too far away, resulting in part of the infantry moving forwards whilst part remained in place, creating a gap in the line the enemy could exploit. At the Battle of Cannae the Romans fielded two double Consular armies for a total strength of 80,000 heavy infantry, but rather than deploy twice or four times as wide the Roman general Varrus chose to deploy in much greater depth, allowing Hannibal to stretch his outnumbered infantry and overlap the Roman line with his African veterans.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn6",
      "id": "ch1_6"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" Command limitations were the single most important factor in how wide infantry could deploy (Hannibal, with a better-trained and more battle-experienced infantry, could not only deploy wider but also execute envelopment manoeuvres that were beyond the raw Roman recruits).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another reason for fixing the number of files at between 800 and 1,600. Trained professional armies of this period rarely "), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_vm._v("exceeded 30,000 men, for the simple reason that this was about as large as an army could be and cover a reasonable distance from campsite to campsite in a single day. It was for this reason that Napoleon split his Grand Armee into corps of 20,000–30,000 men on average that marched separately and united to fight a battle. Presuming half a 25,000 man army was line infantry, if deployed 1,200 yards wide it would form a line about 10 ranks deep which generally was as deep as it needed to be – capable of absorbing an enemy attack whilst most of the ranks kept order and morale intact.")])]), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_vm._v("It is commonly assumed that armies in Antiquity kept to roads or tracks and marched in columns as wide as the road or track available to them. The Roman Empire built an extensive network of roads for military use. Most authors affirm that the Roman infantry marched 6 abreast,")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn7",
      "id": "ch1_7"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])]), _vm._v(" however many Roman roads were wide enough only for a column 4 abreast to march at a comfortable spacing of three feet per file. And where there were no roads usually the best an army could hope for would be tracks wide enough for a cart, allowing the infantry to march two abreast only. The minimum spacing between ranks of a column to allow the soldiers to march without obstructing each other is about 4 feet. At two men per rank, the infantry file alone would stretch for nearly 15km, which would more than double if the cavalry, support personnel and baggage were added. This is impossibly long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gary Brueggeman, in his online study of the Roman marching column, calculated the baggage train for a single legion to be at least 2km long."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn8",
      "id": "ch1_8"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])]), _vm._v(" A Consular army of 4 legions (over 20,000 infantry plus cavalry and support personnel) would have a baggage train more than 11km long. Brueggeman estimates that such an army, marching in a single column at 2.76mph or 4.44km/h, could cover 16km in a day, with 8 hours between the departure of the vanguard from the original campsite to the arrival of the rearguard at the new campsite, leaving them time to care for the pack animals, repair equipment, cook meals, scout the area, forage for food, firewood, restock water supplies, drill and relax.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This however assumes that the infantry march 6 abreast. If, as was often the case, they had only a track allowing them to march 2 abreast, then the distance the army could cover in a day would be reduced to 6–8 km. Clearly something is wrong here.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The tacticians give the answer. None of them affirm that an army necessarily kept to the road it was travelling along, quite the opposite:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The transportation of the baggage is a matter of the utmost importance and requires the responsibility of a special officer. Baggage is conveyed in five various ways: it may move ahead of the army; it may follow behind the army; it may proceed "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("on one flank or the other")]), _vm._v("; or it can proceed in the centre, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("surrounded by troops")]), _vm._v(". – Aelian: 50")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_vm._v("Asklepiodotus gives a variety of formations the army could adopt whilst marching: advancing in lines, oblique lines, curves, squares, half-squares, and multiple columns.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn9",
      "id": "ch1_9"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])]), _vm._v(" When his phalanx marched in column the files now formed the ranks, i.e. creating a column 16 men wide – far wider than the widest road. The Macedonian and Seleucid infantry at least were accustomed to marching off-road, sometimes in highly structured battle formations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vegetius confirms the need to march off-road in order to protect the baggage:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The flanks of the baggage, exposed to frequent ambuscades, must also be covered with a sufficient guard to secure them. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(": 3")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The baggage itself remained a single unit, most probably keeping to the track or road as wheeled vehicles would have difficulty in advancing cross-country. Hence it was the baggage, with the addition of a vanguard and rearguard that determined the minimum length of an army on the march.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A baggage train 11km long, with perhaps an extra kilometre for vanand rear-guards, advancing at 4.44km/h,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn10",
      "id": "ch1_10"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])]), _vm._v(" could cover 35.52km or 22 miles in 8 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vegetius describes how far Roman infantry were expected to march in a given time period:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first thing the soldiers are to be taught is the military step, which can only be acquired by constant practice of marching quick "), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_vm._v("and together. Nor is anything of more consequence either on the march or in the line than that they should keep their ranks with the greatest exactness. For troops who march in an irregular and disorderly manner are always in great danger of being defeated. They should march with the common military step twenty miles [30km] in five summer-hours, and with the full step, which is quicker, twenty-four miles [35.5km] in the same number of hours. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(": 1")])]), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This distance had to be covered in full kit and the infantry practised it regularly:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a constant custom among the old Romans, confirmed by the Ordinances of Augustus and Hadrian, to exercise both cavalry and infantry three times in a month by marches of a certain length. The foot were obliged to march completely armed the distance of ten miles from the camp and return, in the most exact order and with the military step which they changed and quickened on some part of the march. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ibid")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These marches were not confined to roads but took place cross-country, in good and bad terrain:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They made these marches not in plain and even ground only, but both cavalry and infantry were ordered into difficult and uneven places and to ascend or descend mountains, to prepare them for all kinds of accidents and familiarize them with the different manoeuvres that the various situations of a country may require.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaping is another very necessary exercise, to enable them to pass ditches or embarrassing eminences of any kind without trouble or difficulty. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ibid")]), _vm._v(".")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_vm._v("Notice that these are one-day training marches, without the baggage accompanying the infantry and at an optimal speed of 6km/h, but the distances accord nicely with how far an army of about 30,000 individuals could march in a single day at a slower speed to match ")]), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }, [_vm._v("that of the baggage and to prevent excessive fatigue when on a long campaign march that included setting up camp and other duties.")])]), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("If Roman infantry were habituated to marching off-road why then the Roman roads? Three reasons. Firstly the baggage would be able to move at maximum speed without being held up by muddy tracks or difficult terrain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly, a smaller force could keep both its troops and baggage on the road and advance at maximum speed, covering a reasonable distance each day without unduly fatiguing the troops. This would be useful for a rapid redeployment of forces within Roman territory where there was no need for flank guards to protect the baggage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thirdly, the Roman roads were all wide enough to accommodate a wagon-wide baggage train whilst leaving at least half the road free for cavalry or messengers to move rapidly along the column. This would be necessary if an enemy was near, enabling the general to send orders quickly to the different segments of his column and move cavalry with speed to threatened points.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The larger the army, the longer the baggage train and the shorter the distance the army could cover in a day. This is because the tail end of a longer baggage train would leave the camp only much later in the day and hence have less time to cover ground before having to stop for the night.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }, [_vm._v("An army of 60,000 men with the vanguard, baggage and rear guard forming a hypothetical column about 25 km long would be able to cover about 10 km in one day, presuming the baggage advances along a road or track in a single column. A problem arises when considering very large armies, such as the enormous hosts of the Achaemenid Persian Empire. Most modern authors reject the numbers given by the primary sources, nonetheless their own figures often remain very large. Modern estimates of the Persian army at Gaugamela go up to 120,000 men. Such an army would not be able to travel more than about 5km in a day. One wonders how it would manage to cover any significant distance during the campaign season and not strip the countryside to keep itself fed. Without going into detail which is beyond the scope of this book, if such an army advanced across a broad front, over terrain that had been cleared in advance of obstacles that would obstruct the progress ")]), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }, [_vm._v("of troops and baggage, it could cover as much distance per day as a smaller army.")])]), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Returning to the organisation of an infantry line, the arrangement into files lined up side-by-side served a number of purposes which we will look at now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One thing an individual needs when in close-quarter combat is "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("fighting space")]), _vm._v(": this means width but also depth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fighting man needed enough width to be able to use his weapons freely, but not so much width that he could be attacked simultaneously by several enemy troops more closely-arrayed than him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 371 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" a Spartan army of 10,000 infantry and 1,000 cavalry under the command of the Spartan king Cleombrotus invaded the territory of the Boeotian League. The Spartans had the best hoplite troops in Greece and the Boeotian general Epaminondas resorted to a new tactic to overcome them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Greek armies habitually deployed their elite troops on the right of their line to take advantage of a Greek phalanx’s natural tendency to drift to the right. The elite troops, i.e. the best-trained troops, facing fresh air, would be able to execute a left wheel and envelope the left of the enemy line, routing it. Regular citizen hoplites lacked the training to execute this left wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Epaminondas anticipated this and deployed his best infantry and cavalry on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("left")]), _vm._v(" of his line, with the added provision that his Theban troops deployed unusually deep. This part of the line was to advance towards the Spartan elite which faced them and smash it, whilst the rest of the line hung back, waiting to engage only once the mass of Theban hoplites had rattled the enemy by seeing off their best troops.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }, [_vm._v("As the Boeotian line advanced towards the Spartans, the Spartan general Cleombrotus realised what they intended to do and ordered the Spartan right to extend its line rightwards, with the intention of enveloping the Thebans – whose depth meant their formation was not very wide – and smash them. To the left of the Thebans however (or possibly behind them) was the elite unit of Thebes, the 300-man Sacred Band, put there precisely to prevent this from happening. According to the manuals, an infantry line would widen itself by the files increasing the space between themselves, and then having half of each file composed ")]), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }, [_vm._v("of followers move into the newly vacated space to take its place alongside the half of the file composed of leaders, a process known as doubling:")])]), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The width of the phalanx is doubled by number when the frontage of the formation, consisting of 1,024 files, is changed to 2,048 files, by moving a proper number of ‘back-men’ ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistates")]), _vm._v("] into the intervals between the files. – Aelian: 28")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The commander of the Sacred Band, Pelopidas, saw the Spartans commence this manoeuvre and ordered an immediate charge. The Sacred Band ran towards the Spartans and caught them in midmanoeuvre, files widening but with the newly-opened gaps between the files not yet wide enough to accommodate the followers. The Sacred Band, able to fight the Spartans in the front rank at nearly 2 to 1 odds, wreaked havoc among them:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the battle, while Epaminondas was drawing his phalanx obliquely towards the left, in order that the right wing of the Spartans might be separated as far as possible from the rest of the Greeks, and that he might thrust back Cleombrotus by a fierce charge in column with all his men-at-arms, the enemy understood what he was doing and began to change their formation; they were opening up their right wing and making an encircling movement, in order to surround Epaminondas and envelop him with their numbers. But at this point Pelopidas darted forth from his position, and with his band of three hundred on the run, came up before Cleombrotus had either extended his wing or brought it back again into its old position and closed up his line of battle, so that the Lacedaemonians were not standing in array, but moving confusedly about among each other when his onset reached them. – Plutarch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelopidas")]), _vm._v(": 23")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Files were an easy way of regulating space, since the entire spacing of the line depended on the spacing the file leaders adopted, i.e. files kept the spacing in a line uniform, a necessary feature for several reasons which will be seen below.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }, [_vm._v("Generally, the space allotted to each file corresponded fairly closely to the width of a shield. This enabled the soldiers to combine their shields ")]), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }, [_vm._v("into a solid wall of protection, giving enemy weapons no access to them except over the top of the shield rims.")])]), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As important as width was depth. One sees this need for depth in all forms of melee weapon duelling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Have a look the following examples:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fencing:")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=fqZJtCLLFdk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=fqZJtCLLFdk")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Rapier fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=W2q40nsbXZE",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=W2q40nsbXZE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Sabre fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=n5w2Mh6CyXo",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=n5w2Mh6CyXo")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Longsword fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=5zueF4Mu2uM",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=5zueF4Mu2uM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Polearm fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=GSJgPVQJGyk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=GSJgPVQJGyk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Polish spear fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=mYf6FHbA04M",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=mYf6FHbA04M")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Masai spear fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=HGz8uhuHmRc",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=HGz8uhuHmRc")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1_"
  }, [_vm._v("Quarterstaff fighting:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=TMjsHE5p2vs",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=TMjsHE5p2vs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The common denominator of all these contests involving different weapons used in very different ways is the duellists’ need to be able to give ground when necessary, especially when receiving an attack by their opponents’ weapon. A duellist who cannot move backwards is at an immediate and serious disadvantage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A typical file had about three feet between the centre point of each man of the file which allowed the front man a certain amount of give when fighting his opponent:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, a Roman soldier in full armour also requires a space of three square feet. But as their method of fighting admits of individual motion for each man – because he defends his body with a shield, which he moves about to any point from which a blow is coming, and because he uses his sword both for cutting and stabbing – it is evident that each man must have a clear space, and an interval of at least three feet both on flank and rear, if he is to do his duty with any effect. – Polybios, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 18.30")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note that Polybios’ three feet is measured from the centre point of a legionary to the centre point of each legionary beside him and the legionary behind him, which gives the spacing shown in Diagram 2.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_36-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 2: Polybios’ legionary deployment.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is often assumed that Polybios’s legionaries each occupied a width of 6 feet since he affirms that one legionary faced two phalangites in battle and each phalangite occupied a space of 3 feet. This however arises from a misunderstanding of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 18.29 which is commonly rendered as follows:")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }, [_vm._v("Many considerations may easily convince us that, if only the phalanx has its proper formation and strength, nothing can resist it face to face or withstand its charge. For as a man in close order of battle occupies a space of three feet; and as the length of the sarissae is sixteen cubits according to the original design, ")]), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }, [_vm._v("which has been reduced in practice to fourteen; and as of these fourteen four must be deducted, to allow for the distance between the two hands holding it, and to balance the weight in front; it follows clearly that each hoplite will have ten cubits of his sarissae projecting beyond his body, when he lowers it with both hands, as he advances against the enemy: hence, too, though the men of the second, third, and fourth rank will have their sarissae projecting farther beyond the front rank than the men of the fifth, yet even these last will have two cubits of their sarissae beyond the front rank; if only the phalanx is properly formed and the men close up properly both flank and rear")])]), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("And then a little later:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The result of this will be that each Roman soldier will face two of the front rank of a phalanx.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So three feet plus three feet equals six feet. The phrase ‘three feet of space’ is interpreted as three feet of width, which means that for Polybios a close-order phalanx corresponds to the intermediate order of the tacticians, clearly a contradiction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what exactly is Polybios saying? The phrase ‘space of three feet’ translates the Greek: ἐν τρισὶ ποσὶ – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("en trisi posi")]), _vm._v(" – literally ‘in three feet’. What do the three feet refer to? The answer lies in the passage that follows this phrase. After establishing the three feet distance, Polybios goes on to do some maths. A sarissa is 14 cubits (21 feet) long – a cubit being about 1½ feet. Of the 14 cubits, only 10 project in front of the phalangite’s grip. This allows one to calculate how many ranks would have their sarissa project past the front rank. The answer is 5 ranks, with the sarissa of the 5th rank projecting 2 cubits past the front rank men.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }, [_vm._v("But something is missing from the equation: the distance between each rank. Without that factor it is impossible to calculate how many ranks can bring their sarissas to bear beyond the front of the phalanx. Polybios gives that distance. Where? When he states that a phalangite in close order occupied three feet (or 2 cubits), that is, three feet of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("depth")]), _vm._v(". With that figure the maths is easy: 10 cubits minus 2 cubits (4th rank) ")]), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_vm._v("minus 2 cubits (3rd rank) minus 2 cubits (2nd rank) minus 2 cubits (front rank) = 2 cubits of sarissa projecting ahead.")])]), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Polybios indicates the width occupied by the phalangite file when he mentions that the phalanx is in ‘close order’. Each file of a close order phalanx occupies a frontage of one cubit, or about 1½ feet, as described by the tacticians. Hence a Roman soldier occupying a space three feet wide will face two phalangites in close order and ten sarissa-points along with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Does Polybios affirm that Roman soldiers occupied a frontage six feet wide? To reproduce the passage from Livy quoted above:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, a Roman soldier in full armour also requires a space of three square feet. But as their method of fighting admits of individual motion for each man – because he defends his body with a shield, which he moves about to any point from which a blow is coming, and because he uses his sword both for cutting and stabbing – it is evident that each man must have a clear space, and an interval of at least three feet both on flank and rear, if he is to do his duty with any effect. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 18.30")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The phrase ‘a Roman soldier in full armour also requires a space of three square feet’ translates the Greek: ἵστανται μὲν οὖν ἐν τρισὶ ποσὶ μετὰ τῶν ὅπλων καὶ Ῥωμαῖοι – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("istantai men oun en trisi posi meta ton hoplon kai Romaioi")]), _vm._v(". Word for word: ‘they stand so then in three feet with arms also the Romans’. Or in better English: ‘So the Romans also occupy three feet when in arms.’ The ‘also’ refers back to the three feet of depth occupied by the phalangites, hence the meaning is that Romans ranks, like phalangite ranks, are three feet apart.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_vm._v("‘It is evident that each man must have a clear space, and an interval of at least three feet both on flank and rear’ translates the Greek: προφανὲς ὅτι χάλασμα καὶ διάστασιν ἀλλήλων ἔχειν δεήσει τοὺς ἄνδρας ἐλάχιστον τρεῖς πόδας κατ᾽ ἐπιστάτην καὶ κατὰ παραστάτην, – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prophanes hoti chalasma kai diastasin allelon echein deesei tous andras elachiston treis podas")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kat’ epistaten kai kata parastaten")]), _vm._v(". Literally: ‘Clear that looseness [i.e. not to be too tightly packed] and standing-apartness from each other need to have the men at least three feet in respect of those behind and those on ")]), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }, [_vm._v("the side.’ In better English: ‘Clearly the men need to be loosely arrayed and have space between each other – at least three feet to the men behind and the men on either side.’")])]), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One measures the three feet from which point to which point? There can be only two points that apply in all cases: from the midpoint of one file to the midpoint of an adjacent file, or from the midpoint of a rank to the midpoint of the rank behind it. This means in fact that each man occupies a space measuring three by three feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Getting back to the subject of fighting space, if the file leader gave way, the men behind him had no trouble falling back in unison, unlike a disorganised mob in which the front men would find themselves blocked by a mass of men behind them who would not know if they were supposed to give way or not with one front-rank fighter surging forwards and another seeking to recoil. This in fact is why surrounded infantry were invariably slaughtered. Pressed back against each other into a dense mob in which the spacing between files collapsed and the files themselves were no longer able to recoil, the file leaders were obliged to fight exactly where they stood. Their inability to yield ground against enemy strikes whilst the enemy could fall back against their own blows was a deadly handicap for which they had no remedy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This ability to recoil by file gave an additional advantage to the file leader. If he fell back and his opponent advanced to meet him, the latter would find himself facing hostile enemies on three sides and would be quickly cut down. The formation supplied a refuge for a front rank fighter who was momentary outfought, enabling him to recover himself and get back into the fray without being overwhelmed by his adversary. There was however a limit to this kind of protection. If too many file leaders fell back, adjacent file leaders would become exposed in turn to attacks by neighbouring enemy files and would be obliged to give way themselves. This could precipitate a falling-back of the entire formation, which was often a prelude to panic as the men got the idea that their file leaders (supposedly the best fighters of their formation) could not cope with the enemy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }, [_vm._v("Quintus Sertorius was a successful Roman general and Governor of Spain. In the civil war between Marius and Sulla he sided with Marius and when Sulla gained the ascendancy Sertorius retired to Spain, which ")]), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_vm._v("he held for several years against Pompey, Sulla’s protégé. At the Battle of Sucro Sertorius defeated and nearly killed Pompey:")])]), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the fighting was at close quarters, it happened that Sertorius was not himself engaged with Pompey at first, but with Afranius, who commanded Pompey’s left, while Sertorius himself was stationed on the right. Hearing, however, that those of his men who were engaged with Pompey "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("were yielding before his onset and being worsted")]), _vm._v(", he put his right wing in command of other generals, and hastened himself to the help of the wing that was suffering defeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those of his men who were already in retreat he rallied, those who were still keeping their ranks he encouraged, then charged anew upon Pompey, who was pursuing, and put his men to a great rout, in which Pompey also came near being killed, was actually wounded, and had a marvellous escape. – Plutarch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Life of Sertorius")]), _vm._v(": 19.3–4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A line giving way before enemy was usually a precursor to defeat. A file leader might fall back briefly, but he would have to come back into the fight as quickly as possible to cover the men on his flanks. One point about the above example: Roman lines, of which there were habitually three, were meant to fall back one behind the other if they were being outfought by the enemy. In this case however something else was happening: the legion lines as a whole were giving way and the inability of any segment of those legions to hold the enemy in place was clearly a signal the legions were losing the fight. Sertorius had to do something.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Files also made it easy for the front rankers to be replaced the moment they were incapacitated, by the second man in the file simply stepping forward to replace the man in front making the protective line uniform once more.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("File Spacings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to the tacticians there were three spacings for infantry files: open order, intermediate order and close order:")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_vm._v("The needs of warfare have brought forth three systems of intervals: the most open order, in which the men are spaced both in length ")]), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }, [_vm._v("and depth four cubits [about 2 yards] apart, the most compact, in which with locked shields each man is a cubit distant on all sides from his comrades, and the intermediate, also called a ‘compact formation,’ in which they are distant two cubits from one another on all sides – Asklepiodotus: 4.1")])]), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("We will now examine the space allocated to the infantry in terms of both width and depth as there are three different proportions. In the first instance, the men are sometimes arranged in an open order when the situation calls for such a deployment. When so drawn up, each man occupies a space of 4 cubits. When arranged in an intermediate order, each man occupies 2 cubits and, when arranged in a close order, he occupies a space of 1 cubit. – Aelian: 11.")])])]), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a diagram (Diagram 3) of the different spacings: close order at the top, intermediate order below it and open order at the bottom (shield widths for the close and open orders correspond to Macedonian phalangites, and for intermediate order to Greek hoplites).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_41-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 3: Close, intermediate and open order spacing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The open order is a natural disposition without a particular name. The other two orders are found only in a disciplined military context:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The interval of four cubits seems to be the natural one and has, therefore, no special name; the one of two cubits and especially that of one cubit are forced formations. – Asklepiodotus: 4.3")])])]), _c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }, [_vm._v("In an article published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Cross-Cultural Psychology")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn11",
      "id": "ch1_11"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])]), _vm._v(" 8,943 people from various nationalities were tested to determine what distance they would be comfortable with when encountering strangers, acquaintances and family and close friends. The results were then plotted on graphs and showed a range of about 80–150cm for strangers with an average of 115cm. A man’s average shoulder width is about 45cm. Add that to 115cm and you get 1.6m or 3.3 cubits. This tallies well with the ‘natural’ spacing of 4 cubits per file for an open order file, with the men in each file perhaps knowing each other but not being terribly familiar with the men in adjacent files.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is also possible to establish an approximate open order by each soldier of the front rank stretching out arms such that his fingertips touch those of the man beside him. The width of a human arm span is approximately equal to his height, and since a man of that period had an average height of around 170cm, that would give a close enough approximation to 4 cubits (192cm) breadth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A marching formation could advance in open order, two yards per file, the natural spacing of a crowd of men on the move, and which permitted the men to move around obstacles in their path. On the battlefield however, open order served another purpose: it enabled one unit to pass through another, or one unit to insert itself in the other, making use of the file-wide gaps in both cases. Asklepiodotus distinguishes between heavy infantry files inserted between heavy infantry files – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parembole")]), _vm._v(" – and light infantry files inserted between heavy infantry files – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parentaxis")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn12",
      "id": "ch1_12"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])]), _vm._v(" As seen earlier, a formation could widen itself by expanding its files laterally from intermediate order to open order and then having half of one file occupy the spaces between the files. This could be done either by the back half of a file moving up alongside the front half, or every other man of a file stepping sideways to form a new file. The latter enabled the new file to be formed alongside the old one very quickly. This is important as will be seen later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Intermediate order, or one yard per file, was the standard disposition for battle. It corresponded to the width of the 3-feet-wide aspis, or heavy infantry shield, which was the gauge used by Greek hoplites to establish this width: when shields touched edge-to-edge the spacing was right (although Greek phalanxes contracted during their advance towards "), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }, [_vm._v("the enemy, ending up with their shields overlapping each other just before contact with the enemy). This spacing also worked for Roman Republican and Imperial infantry, whose oval or rectangular shields were about 2½ feet wide, leaving a slight gap between one shield and the next which allowed a legionary to move freely in combat.")])]), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }, [_vm._v("There is a final interval of file spacing: close order. The only formation which adopted this order was the Macedonian phalanx and its successors, in which each file occupied a breadth of only one cubit or 48cm,")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn13",
      "id": "ch1_13"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])]), _vm._v(" a little more than the average shoulder width of a man. This compression was possible only because the Macedonian phalangite used a smaller shield with a diameter between 64 and 76cm, with his elbow inserted in a central "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ochanon")]), _vm._v(" and his arm on the right side, making it possible for shields to overlap substantially on the left side."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn14",
      "id": "ch1_14"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])]), _vm._v(" In this formation two phalangites could fight one enemy soldier in intermediate order with predictable results. Provided it preserved its formation, there was nothing that could frontally beat a close-order phalanx except another close-order phalanx. It had to be outflanked or broken up by bad terrain first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These three intervals also applied to the file’s depth, or the spacing between ranks. A file that had adopted open order in depth had about two yards between the centre point of one man of the file and the centre point of the man in front of and behind him. This enabled men of another file to insert themselves in the spaces between the men of the first file to create a new file with twice as many men. It also allowed skirmisher troops space to use their weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A file with an intermediate depth had about a yard between the centre point of each man of the file, which was sufficient to allow the men to use their melee weapons freely. The third spacing, close order, effectively meant the men of a file were so close together the shield of one man was pressed against the back of the man in front of him. This disposition was adopted following – or rather was the natural result of – the infantry tactic known as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("othismos")]), _vm._v(", when the men of a file pushed against each other in an attempt to force the enemy back and break the cohesion of his formation."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn15",
      "id": "ch1_15"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }, [_c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3. Heavy Infantry – Manoeuvres")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The files with their intermediate and open order spacings permitted the infantry formation to execute a variety of manoeuvres. The manuals divide them into four categories: changing the formation’s facing, countermarching, doubling, and insertion or interjection.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Changing the formation’s facing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the means by which a formation was able to change the direction it faced by 90° increments, so as to face to its left, right or to its rear. There were two ways of doing this. The first way was simply for each individual soldier to turn toward his right: ‘turn to the spear’, or towards his left: ‘turn to the shield.’ The formation as a whole did not move or change shape. The kind of change of facing was easy and quick to execute, and was used in the heat of battle to counter an enemy attack against one’s flank, or to attack the flank of an enemy formation oneself.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rightor left-facing, then, is the movement of the individual men, ‘by spear’ to the right, and ‘by shield’ – called in the cavalry ‘by rein’ – to the left; this takes place when the enemy falls upon the flanks and we wish either to counter-attack, or else to envelop his wing, i.e., overlap the wing of the enemy. – Asklepiodotus: 10.2")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The second means was for the formation to wheel as a group around its left or right front corner so as to end up facing towards its left or right. When executing a wheel, the formation would close up first:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is a quarter-turn, when we close up the entire syntagma by file and rank in the compact formation and move it like the body of one man in such a manner that the entire force swings on the first file-leader as on a pivot, if to the right on the right file-leader, and if to the left on the left file-leader, and at the same time takes a position in advance and faces ‘by spear’ if pivoting right and ‘by shield’ if pivoting left. – Asklepiodotus: 10.4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note the term ‘syntagma’ which Asklepiodotus uses to describe a unit composed of 16 files. The syntagma is the basic unit of manoeuvre since its width was equal to its length (the standard size of a Macedonian phalanx file being 16 men). The entire phalanx line could not wheel as a single entity. It had to do it by syntagmas where each probably used the other as a reference point, as shown in diagrams 4–9.")])]), _c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_45-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 4: Syntagma in line.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_45-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 5: The first Syntagma wheels left.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_45-003.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 6: The second Syntagma advances and wheels left.")])])]), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_46-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 7: The third Syntagma advances further and wheels left.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_46-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 8: The third Syntagma aligns with the second.")])])]), _c('a', {
    attrs: {
      "id": "VPS-47"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_47-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 9: The second and third Syntagma align with the first.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As is evident, changing the facing of an infantry line was a complex affair, and could be done only by well-trained regulars. Most Greek hoplite infantry were incapable of it and, in battle after battle, if one wing routed its opponents, it would simply pursue them straight ahead rather than wheel and roll up the rest of the enemy line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A syntagma could execute a double-wheel to end up facing its rear or a triple-wheel to end up facing its flank: right if it wheeled left or left if it wheeled right. A triple-wheel to the right would leave it on the same line with its original position as opposed to a simple 90° wheel to the right, which would leave it further forward from its original position. This might be an important difference if the syntagma was looking to occupy the best terrain.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Countermarching")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-47"
    }
  }, [_vm._v("Countermarching was a manoeuvre that enabled a formation to change its facing by 180° whilst preserving the same order of men in each file, ")]), _c('a', {
    attrs: {
      "id": "VPS-48"
    }
  }, [_vm._v("i.e. the file leaders end up remaining in the front of each file whilst the file closers remain in the rear. This is different from each individual man turning about: in that case each file closer would now be in the front of a file whilst the file leader would be at the back – and the file leader was the best fighter in the file.")])]), _c('a', {
    attrs: {
      "id": "VPS-48"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-48"
    }
  }, [_vm._v("Countermarching required that the formation be in open order, with each file occupying a frontage of two yards, leaving a gap between one file and the next. There were three ways of executing the manoeuvre.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn16",
      "id": "ch1_16"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Macedonian countermarch")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each file leader turns 180° to face towards his rear. The rest of the file then marches past him and takes up position behind him, ending up with the file facing the same direction as the file leader and in the same order behind him as it was originally (see Diagram 10).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_48-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 10: The Macedonian countermarch.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There was one problem with the Macedonian countermarch. Countermarching was done, among other reasons, to enable a phalanx formation to face an enemy approaching it from the rear. When countermarching in this fashion, it gave the impression that the phalanx was retreating from the enemy, and impressions are everything in ancient warfare. This might hearten the enemy and convince them to attack with greater "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("élan")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-49"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Laconian countermarch")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To offset this, a formation could try the Laconian countermarch. With this method, each man in the file first turned 180° to face towards his rear. The file leader now found himself at the rear of the file whilst the file closer was now at the front. The file leader then marched down the gap between his file and the adjacent file, passed the file closer, and took up a position in front of him at the same distance he had occupied in the rear. The rest of the file followed the file leader and took up its new position behind him. When the manoeuvre was complete, the file closer now found himself at the rear of the file (see Diagram 11).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_49-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 11: The Laconian countermarch.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Choral/Cretan/Persian countermarch")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-49"
    }
  }, [_vm._v("There was a third option if the phalanx wanted to stay on the same ground it already occupied, and that was the Coral or Cretan or Persian countermarch. In this manoeuvre, the file leader marches down the side of the file. The second man in the file meanwhile advances until he stands on the spot originally occupied by the file leader. The rest of the file move up behind the second man. The file leader reaches the spot originally occupied by the file closer and stops, facing 180° away from the rest of the file. The second man in the file marches down the side of the file whilst the third man followed by the rest of the file moves up to occupy the position vacated by him. The second man takes his place ")]), _c('a', {
    attrs: {
      "id": "VPS-50"
    }
  }, [_vm._v("behind the file leader and the third man marches down the side of the file, and so on until the file closer reaches the spot originally occupied by the file leader. He turns round and now the entire file is facing 180° from its original orientation whilst still occupying the same ground as before (see Diagram 12).")])]), _c('a', {
    attrs: {
      "id": "VPS-50"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_50-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 12: The Choral/Cretan/Persian countermarch.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Countermarching could also be done by rank, i.e. swopping positions of the men at the wings with the men in the centre of the phalanx by moving them along the spacing between one rank and the next, with the ranks naturally in the open order spacing. This however took time, as the width of a phalanx was many times greater than its depth (about a kilometre in width for the ideal phalanx of 16,384 men envisaged by the manuals, as opposed to about 16 metres in depth). Which made it unwise to attempt it in proximity to the enemy who, seeing the switch taking place, could charge the formation before the manoeuvre was complete, catching the phalanx in a state of confusion before files were properly reformed.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Doubling")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Doubling comes in two kinds, of which each kind has two further subdivisions, giving four kinds of doubling in total.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-50"
    }
  }, [_vm._v("In the first kind the width and depth of the phalanx remain unchanged, but the files or ranks are doubled in number. Files are doubled in number by every even-numbered man (the ‘back-man’ or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistates")]), _vm._v(" in a file) stepping sideways into the space between the files to form a new file. This condenses open order files into intermediate order files, or intermediate order files into close order files. The spacing between the ")]), _c('a', {
    attrs: {
      "id": "VPS-51"
    }
  }, [_vm._v("ranks is increased. The ranks could then close up to restore the previous spacing between them (see Diagram 13).")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn17",
      "id": "ch1_17"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_51-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 13: Doubling: the first method.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aelian in describing this process does not recommend it:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("However, there are some who disapprove of doubling in this manner, especially when an enemy is close at hand, and choose rather to place the light-armed troops and the cavalry on the wings, so as to give the appearance of the phalanx being doubled, when, in fact, the phalanx remains as it was in its usual order. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 28")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The reason for this reticence is clear: the front-rank man of the newlyformed second file is neither a file leader nor as good a fighter as the file leader. Furthermore the original file will lose its file-closer – the man responsible for good order and fighting commitment of the file – as he moves across to form the last man of the new file. Both files’ fighting ability is thus compromised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is however an advantage to this method of doubling. First, it can be done very quickly and secondly, it enables phalangites in intermediate order to form close order files whilst keeping their shields in front of them – an impossibility if rearward files were obliged to march down the spaces between intermediate-order frontward files. Doubling in this manner is useful then as an emergency manoeuvre in the heat of combat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rather than doubling files to form a close-order phalanx, Aelian recommends something different: the phalanx closes up its files, reducing its width."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn18",
      "id": "ch1_18"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])]), _vm._v(" Light troops and cavalry occupy the space on its flanks to compensate for the narrower frontage.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The manuals curiously enough do not mention doubling files by the rear half-files marching up alongside the front half-files, even though the existence of half-files as separate units with their own officers would suggest that this happened (see Diagram 14).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_52-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 14: Doubling by moving up rear half-files.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-52"
    }
  }, [_vm._v("Aelian however does describe the reverse process: even-numbered files countermarching to the rear and taking up position behind oddnumbered files, which suggests this technique was also used to double the number of files.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn19",
      "id": "ch1_19"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ranks can also be doubled in number by a reverse process: one file joins another file next to it to become a new file with double the number of men of each original file. This is accomplished by men of one file inserting themselves between the men of another, effectively becoming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistates")]), _vm._v(" or the even-numbered men of the file. It requires that there be initially at least an intermediate spacing between the ranks of one yard per rank to permit the men to fit (see Diagram 15)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn20",
      "id": "ch1_20"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_52-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 15: Doubling ranks.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The second kind of doubling increases the width or depth of the phalanx. Doubling by width happens when the files spread out laterally, from intermediate to open order or from close to intermediate order. This kind of doubling is often followed by a doubling of the number of files as described above, to bring the phalanx from open order back to intermediate order.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-53"
    }
  }, [_vm._v("This doubling can also be achieved by the even numbered ranks countermarching to the flank (see Diagram 16).")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn21",
      "id": "ch1_21"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_53-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 16: Doubling by width.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doubling by depth happens when the even-numbered files countermarch to the rear and take up station behind the odd-numbered files, creating new files with double the number of men and also double the original length (see Diagram 17)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn22",
      "id": "ch1_22"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_53-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 17: Doubling by depth.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-54"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Insertion and interjection")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-54"
    }
  }, [_vm._v("Insertion ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parentaxis")]), _vm._v(") and interjection ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parembole")]), _vm._v(") are essentially the same thing. In the case of insertion, the files of a phalanx are in open order, and the spaces between the hoplite files are occupied by files of light troops: peltasts or skirmisher foot. You thus have a formation in which half the files are heavy infantry and half are light troops. Since light troops are half the number of heavy troops their files will have half as many men.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn23",
      "id": "ch1_23"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])]), _vm._v(" Interjection is the same as insertion with the difference that heavy infantry files occupy the spaces between the files of a phalanx. In other words the phalanx consists of two heavy infantry formation intermeshed together."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn24",
      "id": "ch1_24"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only the best trained troops were capable of all these formation changes and manoeuvres. The average Greek citizen hoplite, for example, could form a line with files in intermediate order – shield rims touching – but could do little else. Only full-time professionals like the Spartans, the Theban Sacred Band, and the Macedonian and Roman infantry could execute wheels, countermarches and doublings. But the ability or inability to adapt one’s formation to the needs of the battlefield and perform manoeuvres at crucial moments of the battle became increasingly important at time went by, eventually resulting in the massive and poorlytrained irregular armies of Spain, Gaul and the Fertile Crescent giving way to the much smaller professional forces of Macedonia and Rome.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4. Cavalry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cavalry formations were all about shape. Unlike infantry, cavalry did not necessarily form up in files and ranks. They could form files without ranks, ranks without files, or have neither ranks nor files. Cavalry vs cavalry engagements were usually straightforward frontal affairs, but against infantry more care was needed. A cavalryman needed to keep moving when attacking foot soldiers as he was extremely vulnerable if his horse was brought to a standstill. Immobile in a body of infantry he would not last long as he was in an exposed position on his horse, surrounded by enemy on all sides and locally outnumbered. The one exception to this was cataphract cavalry. Both horse and rider were armoured and the horses were obliged to keep close together, presenting a solidly-protected front against enemy foot.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cavalry formations came in three fundamental shapes: the rhomboid, the wedge and the square. Cavalry were mobile entities, meant to manoeuvre around infantry formations and either harass them from a distance or attack them in their vulnerable flanks or rears. But they were also capable of assaulting infantry frontally. Depending on how cavalry was intended to operate on the battlefield, it adopted the shape that best suited its purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Square formation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cavalry square was used by the Persians and Sicilians and, in a modified form, by the Greeks. The square has a number of advantages, the first being that it is easy to keep in alignment as it is composed of ranks and files, like the infantry. The riders simply had to keep behind the men in front of them in their file and stay alongside the men in adjacent files.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Persians, Sicilians, and Greeks regularly used the square formation since it can hold the squadrons in both rank and file. – Asklepiodotus: 7.4")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Persians, the Sicilians and, generally speaking, the Greeks used square formations, being of the opinion that they were more easily formed and better suited to the easy preservation of the formation and general use. – Aelian: 18.5")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There were other advantages to a square. In a charge, the best riders of the formation, the file leaders, would all contact the enemy at the same time, applying maximum shock effect:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Additionally, in this form only, the experienced officers have the ability to charge the enemy simultaneously. – Aelian: 5.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("And alone of all these formations, all the leaders fall on the foes together. – Arrian: 16.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-55"
    }
  }, [_vm._v("Another bonus was the ability of a square formation to break off easily from the enemy. Polybios in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(", when describing the frontage of the Greek cavalry at the Battle of Issus, gives each file a width of ")]), _c('a', {
    attrs: {
      "id": "VPS-56"
    }
  }, [_vm._v("2 yards, in other words, a cavalry file corresponds to an open order infantry file in terms of lateral space:")])]), _c('a', {
    attrs: {
      "id": "VPS-56"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the most cavalry in a regular engagement is drawn up eight deep, and in the midst of [μεταξύ – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("metaxu")]), _vm._v("] each of the squadrons there is need for a space equal to the fronts [of the squadrons] inasmuch as it is equivalent to [squadrons] wheeling [left/right] and caters for [squadrons] wheeling about [to their rear]. Therefore eight hundred will cover a stade [200 yards] of front; eight thousand, ten stades; three thousand two hundred, four stades; and so eleven thousand two hundred would cover the whole of fourteen stades [of the Greek cavalry]. – Polybios, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 12.18.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is worthwhile taking a little time to examine this passage. Generally it is interpreted as a line of cavalry that is split into separate squadrons with squadron-wide gaps between them, rather like the popular conception of the punctuated chequerboard lines of the Republican legion. The gaps allow the squadrons to wheel 180 degrees and retire through the spaces to their rear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This interpretation means that each squadron with 100 horses in the front rank is only 100 yards wide with a gap also 100 yards wide to its right and left. This consequently means that each file of horses is only 1 yard wide – horses in adjacent files will be a only few inches from each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This poses all sorts of problems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, the horses, a foot or less apart, will be unable to turn individually in place, something which Asklepiodotus affirms they can do:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Right- or left-facing, then, is the movement of the individual men, ‘by spear’ to the right, and ‘by shield’ – "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("called in the cavalry ‘by rein’")]), _vm._v(" – to the left; this takes place when the enemy falls upon the flanks and we wish either to counter-attack, or else to envelop his wing, i.e., overlap the wing of the enemy. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 10.2.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-56"
    }
  }, [_vm._v("Secondly, an entire mounted formation, the rhombus, becomes impossible as it is built around the ability of the horses to turn ")]), _c('a', {
    attrs: {
      "id": "VPS-57"
    }
  }, [_vm._v("individually in place and face one of its four corners, enabling rapid changes of direction and movement.")])]), _c('a', {
    attrs: {
      "id": "VPS-57"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Thirdly the squadrons will have exposed and vulnerable flanks, inviting an enemy to pour through the gaps and hit each squadron on three sides, a sure recipe for disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fourthly there is the difficulty of maintaining a continuous line of squadrons separated by large gaps that must be kept at the correct width at all times to enable the squadrons to wheel around into them if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What then to make of Polybios?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The key to understanding this passage is the word μεταξύ – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("metaxu")]), _vm._v(", best rendered as ‘in the midst of ’, with the possible meanings of ‘between’ or ‘among’, depending on the context. So taking another look at the passage:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("… and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the midst of")]), _vm._v(" [μεταξύ] each of the squadrons there is need for a space equal to the fronts [of the squadrons] inasmuch as it is equivalent to [squadrons] wheeling [left/right] and caters for [squadrons] wheeling about [to their rear].")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is need for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" space in the midst of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("each")]), _vm._v(" of the squadrons. The implication is that the space is within the squadron. ‘Space’ translates διάστημα – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("diastema")]), _vm._v(", which means a stretch or extension that may or may not be occupied by something. The three dimensions of an object – length, breadth and height – are signified by διάστημα.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This space is ‘equivalent to’ – δύνασθαι – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dunasthai")]), _vm._v(" – the squadron ‘wheeling to the right or left’ – ἐπιστροφαῖς – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistropsais")]), _vm._v(". δύνασθαι can also mean ‘to be able to’ but that does not fit this context as no formation needs space either within or next to it to be able to execute a 90 degree wheel. Furthermore using "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dunasthai")]), _vm._v(" in the sense of ‘to be able to’ comes out as ‘the [squadrons] wheeling left/right to be able to’ – do what? The Greek does not say and the clause is left hanging in mid-air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Asklepiodotus affirms that when a formation executes a wheel it first contracts to close order:")])]), _c('a', {
    attrs: {
      "id": "VPS-58"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is a quarter-turn ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epistrophe")]), _vm._v("], when we close up the entire battalion by file and rank in the compact formation and move it like the body of one man in such a manner that the entire force swings on the first file-leader as on a pivot, if to the right on the right file-leader, and if to the left on the left file-leader, and at the same time takes a position in advance and faces ‘by spear’ if pivoting right and ‘by shield’ if pivoting left. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 10.4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Closing up from open to intermediate or from intermediate to close order halves the frontage of a formation. From this perspective, the space required is equivalent to the wheeling squadron, not to the squadron originally in line, and hence is half the width of the squadron before it wheels. If there was no difference in width between a wheeling and a stationary squadron Polybios would have had no reason for applying the space specifically to the wheeling squadron.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So what Polybios in effect is saying is that when squadrons with 100 horses per rank are in line they are one stade (200 yards) wide. Within that width there is enough space that when the squadron closes up to a width of 100 yards this leaves a space next to it of the same width, 100 yards, that ‘caters for [squadrons] wheeling about [to their rear]’, i.e. enables squadrons to wheel around and retire without bumping into adjacent squadrons as would happen if they kept to their original spacing (see Diagram 18).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problem is solved if the horse files compact together before wheeling, as in Diagram 19.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In conclusion, a cavalry force of 800 men deployed 8 deep with 100 cavalrymen in front rank will spread across the entire stade – 200 yards – with each man occupying a frontage of two yards, or six feet. A horse from nose to tail measures about 7 feet. The spacing will look as in Diagram 20.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is much looser than an infantry formation. Each horse that has charged enemy can easily wheel and retire down the gaps between the files, or the entire unit can face about simultaneously and break off. When turning around, the horses will have a lateral space of 6 feet, which is enough to avoid colliding with the horses in adjacent files (the horses raise their heads when turning to shorten their body length). The square can remain in movement: charging infantry, breaking off and then facing about to charge again. The infantry never get the chance to grapple with individual horsemen.")])]), _c('a', {
    attrs: {
      "id": "VPS-59"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_59-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 18: Squadrons wheeling left in regular order.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_59-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 19: Squadrons closing up before wheeling")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_59-003.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 20: Cavalry spacing.")])])]), _c('a', {
    attrs: {
      "id": "VPS-60"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Indeed this formation is more easily deployed than any other, in that the riders, being deployed by row and column, it provides easier "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("attacks and retreats")]), _vm._v(". – Arrian: 16.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-60"
    }
  }, [_vm._v("Besides wheeling as described above, breaking off can be done in one of two ways, by each horseman wheeling, generally to the right")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn25",
      "id": "ch1_25"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("25")])]), _vm._v(" so as to be covered by his shield, and moving back through the gaps between the files – effectively countermarching. This would especially suit a ranged missile attack, each rank coming within range of enemy infantry, throwing its javelins, then breaking off to allow the next rank to throw its javelins in turn (see Diagram 21).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_60-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 21: Breaking off by countermarching.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Breaking off can also be done by all the horsemen turning about in place and the entire formation moving off. This would be appropriate for a charge that had not succeeded in penetrating or routing enemy infantry or cavalry (see Diagram 22).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-61"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_61-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 22: Breaking off by turning.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This raises a question: if a square cavalry formation can execute a 180 degree change of direction simply by countermarching to its rear then why does Polybios describe cavalry doing 180 wheels by squadron as described above? Wheeling is a much slower and more vulnerable procedure: a line of squadrons that retires by countermarching will be facing the enemy at all times whilst executing the manoeuvre. Wheeling squadrons need more time to complete the manoeuvre and present vulnerable flanks to the enemy whilst in the wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One possible answer is that wheeling by squadron is a much more natural process for horses that tend to follow each other in the same direction, whilst countermarching involves horses moving in a direction opposite to the facing of adjacent horses, which goes against their grain. Hence countermarching requires better-trained horses than wheeling and cavalry may not always have that degree of training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Squares came in two kinds. For the first kind the number of ranks matched the number of files, which in fact produced an oblong rectangle that was much deeper than it was wide given the length-to-width ratio of a horse (see Diagram 23).")])]), _c('a', {
    attrs: {
      "id": "VPS-62"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_62-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 23: Cavalry in ‘square’ with as many files as ranks.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The second kind was square in shape, which was accomplished by having more files than ranks: twice as many files as ranks or even three times as many files as ranks.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("… the Greeks modified the squadron formation by making it an oblong in mass, while giving it to the eye the appearance of a square. For they drew up the riders with a front of sixteen and a depth of eight, but they doubled the interval between the riders because of the length of the horses. And some made the number of men in length three times that of the depth and then tripled the interval in depth, so that it again appeared to be a square… – Asklepiodotus: 7.4")])])]), _c('a', {
    attrs: {
      "id": "VPS-63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Diagram 24 shows a square with twice as many files as ranks. The distance between the riders in rank is twice that of the riders in file:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_63-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 24: Cavalry in square with twice as many files as ranks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Diagram 25 shows a square with three times as many files and ranks, and with the rank spacings triple those of the file spacings. Notice that the distance between each rank allows for one rank to break off from the enemy whilst leaving enough distance for the next rank to get up the speed to charge into contact:")])]), _c('a', {
    attrs: {
      "id": "VPS-64"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_64-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 25: Cavalry in square with three times as many files as ranks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this passage doubling the interval between the riders means that the riders themselves (not their horses) were twice as far from the men behind and in front of them as they were from the men in either side of them. This meant that in the doubling option, there were 4 yards between the bodies of each rider in a file, which meant about 2 yards between the nose of a horse and the tail of the horse in front of him. For the tripling process, the riders in a file were 6 yards and the horses 4 yards apart. This ensured the horses never came too close together. Unlike infantry, cavalrymen in rear ranks gave no support to cavalrymen further forward in the line. If the horses came in contact with each other it was likely to disrupt the formation:")])]), _c('a', {
    attrs: {
      "id": "VPS-65"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Those following in the rear ranks in no way support the leaders as happens in infantry formation. The rear ranks do not contribute to how well and enemy charge is resisted, nor do they increase the momentum of those before them, nor close up with them, nor, holding on to each other, make a solid mass. If the leading files are pressed forward from the rear, the horses become annoyed, create disorder and are more likely to do harm to themselves than to the enemy. – Aelian: 18")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The maximum recommended depth for a cavalry square that intended to engage in hand-to-hand combat with the enemy was 8 horses, though cavalry that engaged in ranged missile combat could deploy deeper, with more ranks to deliver a succession of javelins or arrows to the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhombus Formation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rhombus, or diamond-shape, was originally used by Thessalian cavalry and later incorporated into the Macedonian army. Each corner of the diamond was occupied by an officer who could lead the entire squadron if its men faced left, right or to the rear. This meant the rhombus could change facing immediately and head off in a new direction by the simple expedient of each man turning his horse. This made the rhombus very agile on the battlefield, able to turn right or left or to its rear and, still in formation, attack enemy immediately. It was impossible to attack a rhombus in the flank since it could turn to meet a flank charge in a second or two.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It appears that the Thessalians were the first to use the rhomboid formation for their squadrons in cavalry fighting, and this with great success both in retreat and in attack, that they might not be thrown into disorder, since they were able to wheel in any direction; for they placed their crack troopers on the sides and the very best of these at the angles; and they called the man at the fore angle a squadron-commander ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ilarches")]), _vm._v("], the one at the rear angle a squadron-closer ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("uragos")]), _vm._v("], and those on the right and left angles flank-guards ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("plagiophylakes")]), _vm._v("]. – Asklepiodotus: 7.2.")])])]), _c('a', {
    attrs: {
      "id": "VPS-66"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-66"
    }
  }, [_vm._v("The formation comes in four variants: a) with files and ranks, b) with files but without ranks, c) with ranks but without files, d) with neither files nor ranks.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn26",
      "id": "ch1_26"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first variant, with ranks and files, is shown in Diagram 26.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_66-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 26: Cavalry in rhombus with files and ranks.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Like the square, it had the advantage of being easy to maintain: the men in a file simply had to keep in line with the men in front of them and remain abreast of the men in adjacent files. When the rhombus turned right or left, the new files would need to increase in length to separate the horses from each other and also contract together to recreate the original shape (see Diagrams 26–29).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_67-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 27: The cavalry begin the turn.")])])]), _c('a', {
    attrs: {
      "id": "VPS-68"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_68-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 28: The turn is complete.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_68-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 29: The files contract and the ranks open out to resume original spacing.")])])]), _c('a', {
    attrs: {
      "id": "VPS-69"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The second variant, with files but without ranks, is shown in Diagram 30.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_69-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 30: Cavalry in rhombus, files but no ranks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flattened angle of the leading edge of the rhombus is due to the horses on either side of the lead horseman reaching to the shoulders of his horse, as described by Aelian:")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-69"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-69"
    }
  }, [_vm._v("When the leader of the troop ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ilarch")]), _vm._v("] is placed at the head of the formation, the next succeeding horsemen, on either side of him, ought not to form a rank behind the leader, but should be positioned so that the heads of their horses reach to the shoulders of the horse upon which the leader is mounted. To allow the men to preserve the due distance from each other, those that are posted on the right and left, and those positioned to the rear, should avoid the disorder that can arise in the case of the horses coming into close contact with each other; for some horses, vicious by nature, are apt to do harm to the soldiers and horses around it by bucking and rearing ")]), _c('a', {
    attrs: {
      "id": "VPS-70"
    }
  }, [_vm._v("and turning about (due to its long shape) and by lashing out with its feet at the horses upon which the soldiers are mounted. – Aelian 19")])]), _c('a', {
    attrs: {
      "id": "VPS-70"
    }
  })]), _c('a', {
    attrs: {
      "id": "VPS-70"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trying to create a perfectly shaped rhombus with this arrangement would leave the horses dangerously close to each other, as shown in Diagram 31.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_70-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 31: Cavalry in overly closed rhombus.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When turning right or left, the horsemen would need to take a little care in reforming the files correctly before resuming the front-flattened diamond shape again (see Diagrams 30–35).")])]), _c('a', {
    attrs: {
      "id": "VPS-71"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_71-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 32: The cavalry begin the turn.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_71-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 33: The turn is complete, but the files are out of alignment.")])])]), _c('a', {
    attrs: {
      "id": "VPS-72"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_72-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 34: Correcting the files.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_72-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 35: The manoeuvre is complete.")])])]), _c('a', {
    attrs: {
      "id": "VPS-73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This variant enabled the rhombus to charge an enemy unit with nearly the same simultaneous impact as a cavalry square.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third variant, with ranks but without files, is shown in Diagram 36.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_73-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 36: Cavalry in rhombus, ranks but no files.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This rhombus was very narrow which gave it several advantages. The first was the ability to slip through tight gaps, either in terrain or in an enemy line. The second advantage was to convince the enemy the cavalry formation was smaller than its actual size and precipitate them into making a foolhardy attack:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("[this rhomboid] narrowest along the forehead would be most useful if it were necessary to conceal the horsemen’s depth so as to summon the foes out into disadvantageous boldness. – Arrian: 17.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fourth variant had neither ranks nor files and looked as in Diagram 37.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the most flexible of the four variants. The horses have plenty of space for turning and the rhombus, virtually square in shape, needs very little adjustment once the cavalrymen have turned right or left.")])]), _c('a', {
    attrs: {
      "id": "VPS-74"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_74-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 37: Cavalry in rhombus, no ranks or files.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wedge Formation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A wedge is effectively the front half of a rhombus. None of the manuals specify whether there were different kinds of wedges as there were rhombuses, but as they were based on the rhombus it is probable they varied in structure (see Diagrams 38–41).")])]), _c('a', {
    attrs: {
      "id": "VPS-75"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_75-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 38: Cavalry in wedge, variant 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_75-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 39: Cavalry in wedge, variant 2.")])])]), _c('a', {
    attrs: {
      "id": "VPS-76"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_76-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 40: Cavalry in wedge, variant 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_76-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 41: Cavalry in wedge, variant 4.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The principal advantage of a wedge is that it is the best configuration for breaking through an enemy formation:")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-76"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-76"
    }
  }, [_vm._v("It is said that the Scythians and Thracians invented the wedge formation, and that later the Macedonians used it, since they considered it more practical than the square formation; for the ")]), _c('a', {
    attrs: {
      "id": "VPS-77"
    }
  }, [_vm._v("front of the wedge formation is narrow, as in the rhomboid, and the wedge is only half the size, and this made it easiest for them to break through, as well as brought the leaders in front of the rest, while wheeling was thus easier than in the square formation, since all have their eyes fixed on the single squadron-commander, as is the case also in the flight of cranes. – Asklepiodotus: 7.3")])]), _c('a', {
    attrs: {
      "id": "VPS-77"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("We hear that the Scyths especially have used wedges and, having learned from the Scyths, the Thracians. Even Philip the Macedonian trained the Macedonians to use this formation. The same formation also seems useful because its leaders are close together and its sharply broken off ‘forehead’ easily provides the means to cut through every enemy formation. – Arrian: 16")])])]), _c('a', {
    attrs: {
      "id": "VPS-77"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why exactly is a wedge so apt for slicing through enemy units? To attempt to answer the question fully is beyond the scope of this book. One thing to notice for now is that, unlike a rhombus where the best riders (and fighters) were spread along all four sides of the formation, in the wedge they were concentrated on the two leading edges on either side of the front point, giving the wedge more effective combat-power when it hit the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wedges do not change direction right or left like rhombuses, but wheel as an entire unit following the wedge leader. A wedge however is quite capable of countermarching in order to execute a 180 degree change of direction (see Diagrams 42–47).")])]), _c('a', {
    attrs: {
      "id": "VPS-78"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_78-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 42: Cavalry wedge, advancing.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_78-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 43: Cavalry wedge, the leader begins the countermarch.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_78-003.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 44: Cavalry wedge, the second rank begin the countermarch.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_78-004.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 45: Cavalry wedge, the countermarching troops pass through the rear ranks.")])])]), _c('a', {
    attrs: {
      "id": "VPS-79"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_79-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 46: Cavalry wedge, the rear ranks begin to turn.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_79-002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 47: Cavalry wedge, the countermarch is complete.")])])]), _c('a', {
    attrs: {
      "id": "VPS-80"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mixed Cavalry/Skirmisher Foot Formation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One last configuration that proved effective especially against enemy cavalry was the mixed formation. This consisted of inserting light, missile armed infantry within the cavalry files, possible since there was a space of about 4 feet between one file and the next. This would have doubled the amount of missiles the formation could loose at the enemy, and further augmented its efficacy since a man on foot can cast a javelin or loose and arrow or slingstone harder and further than a mounted man in a sitting position. Furthermore, in melee combat a horseman in an all-cavalry unit would find himself confronting two opponents in a mixed formation – a cavalryman and a skirmisher foot, the latter ideally placed to kill or otherwise incapacitate his horse whilst he was kept occupied by his mounted opponent.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cavalry on the side of his opponents were disposed like an ordinary phalanx of heavy infantry, regular in depth and unsupported by foot-soldiers interspersed among the horses. Epaminondas again differed in strengthening the attacking point of his cavalry, besides which he interspersed footmen amongst their lines in the belief that, when he had once cut through the cavalry, he would have wrested victory from the antagonist along his whole line. – Xenophon: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hellenica")]), _vm._v(": 7.12.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ploy worked:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At first they engaged in a cavalry battle on the flanks … as the Athenian horse attacked the Theban they suffered defeat not so much because of the quality of their mounts nor yet on the score of the riders’ courage or experience in horsemanship … but it was in the numbers and equipment of the light-armed troops and in their tactical skill that they were far inferior to their opponents. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ibid")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The mixed formation may have looked like Diagram 48, in which the skirmisher foot are safe from a charge by enemy cavalry and have plenty of space to wield their weapons.")])]), _c('a', {
    attrs: {
      "id": "VPS-81"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_81-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 48: The mixed formation.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Countermarching by cavalry is still possible since the skirmisher foot are able to insert themselves into the cavalry files, clearing the file gaps for the countermarching horses to pass, after which the skirmisher foot return to their original position and allow the horses behind them to move up. It would require co-ordination and training to accomplish.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5. Skirmisher Infantry")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-81"
    }
  }, [_vm._v("According to the Hellenistic manuals the light troops were ideally half as numerous as the heavy foot. They were organised much like the heavy infantry, having as many files, but with half the number of men per file. They were always positioned with heavy infantry, either before, ")]), _c('a', {
    attrs: {
      "id": "VPS-82"
    }
  }, [_vm._v("behind or even within a heavy foot formation. When positioned before or behind the heavy foot they matched them file for file:")])]), _c('a', {
    attrs: {
      "id": "VPS-82"
    }
  }), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-82"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The name and size of the various units of light troops are as follows [then a description of the various light infantry units] 8,192 men arranged in 1,024 files. – Aelian: 16")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Now these light infantry will also have 1,024 files, if they are to stand behind the phalanx of the hoplites and extend the same distance, without, however, a depth of sixteen men – for they are only one half as strong – but obviously of eight men. – Asklepiodotus: 6.2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The light infantry and peltasts will be stationed by the general as the situation demands, sometimes before the line of battle, sometimes behind it, and on other occasions now on the right flank and again on the left; the first is called van-position ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protaxis")]), _vm._v("], the second rear-position ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hypotaxis")]), _vm._v("], and the third flank-position ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prosentaxis")]), _vm._v("]. Sometimes they are incorporated in the phalanx and stationed one beside each man; and this is called insert-position ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parentaxis")]), _vm._v("], because there is an insertion of different branches of the service, e.g., light infantry with hoplites – Asklepiodotus: 6.1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sometimes the psiloi will be positioned in the front of the line, while at other times they will be positioned behind the line, depending upon the tactical requirements of each situation. They may, for example, be formed in this manner: arranged into 1,024 files (the same number of files as are in the phalanx itself) they will, however, be positioned so that the first file of psiloi is directly behind the first file of the phalanx, the second file of light troops behind the second file of the phalanx, and so on. The files of the light infantry ought not to be sixteen men deep, but only half that number, namely eight deep. Thus, 1,024 files of light troops will contain 8,192 men – Aelian: 15")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Protaxis [πρόταξις] describes the positioning of the light-armed troops in front of the armed infantry who make up the phalanx.")])]), _c('a', {
    attrs: {
      "id": "VPS-83"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The repositioned light troops then assume the role of file-leaders, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protostatae")]), _vm._v(". – Aelian: 30.")])])]), _c('a', {
    attrs: {
      "id": "VPS-83"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why were light troops half as numerous as the heavies?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two reasons. First, all the three types of skirmishers – javelinmen, archers and slingers – need plenty of depth to use their weapons. An archer at full draw has a depth of about four feet and so would require about six feet to remain clear of the men in front of and behind him. This also applies to a slinger and a javelinman. For Vegetius, all Roman infantry were trained to use javelins:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Besides the aforementioned exercise of the recruits at the post, they were furnished with javelins of greater weight than common, which they were taught to throw at the same post. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(": 1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The distance between ranks of Vegetius’ infantry was 6 feet. This distance, double that of Polybios who described the intervals of Roman infantry when using their swords, gives the soldier the space to cast his javelin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly, great depth did not serve any purpose for skirmisher troops and, at least in the case of javelinmen, could dangerously limit the range of their weapons. A line of javelin 8 men deep at two yards per rank would be 16 yards deep. A line of 16 ranks would be 32 yards deep.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-83"
    }
  }, [_vm._v("How far did ancient javelineers throw their javelins? In a study")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn27",
      "id": "ch1_27"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("27")])]), _vm._v(" by Steven Ross Murray, William A. Sands and Douglas A. O’Roark of the Colorado Mesa University, a test was made of the range of an ancient Greek javelin. Two highly trained collegiate throwers, using a run-up and proper throwing technique, threw a facsimile of an ancient Greek javelin with and without the use of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ankyle")]), _vm._v(" (ancient leather throwing strap). Without the ankyle throws ranged between 33.2 and 49.5 yards. With an ankyle they ranged between 56.5 and 66.2 yards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presuming that ancient javelineers were more experienced with the ankyle and could throw further, their maximum range would probably not on average exceed about 70–80 yards. In this context, a difference of 16 yards matters. The javelineers, throwing from in front of a heavy infantry line, could not allow the enemy to get too close: they had to be "), _c('a', {
    attrs: {
      "id": "VPS-84"
    }
  }, [_vm._v("able to retire through the heavy infantry files leaving enough time after they had passed for the heavy infantry to double their files from open to intermediate formation and be ready for the onset of the enemy foot. The shallower the javelin line the better.")])]), _c('a', {
    attrs: {
      "id": "VPS-84"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For slingers and archers, lines that are too deep posed a different problem. Vegetius states that slingers cast their stones overhead and that slingers and archers trained to hit a target 200 yards away:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The archers and slingers set up bundles of twigs or straw for marks, and generally strike them with arrows and with stones from the fustiablus at the distance of six hundred feet. They acquired coolness and exactness in action from familiar custom and exercise in the field. The slingers should be taught to whirl the sling but once about the head before they cast the stone. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Re Militari")]), _vm._v(": 2.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("200 yards is little below the extreme distance a skirmisher bow could shoot. Slingers could cast a little further than a bowshot, but in round numbers 200 yards is a convenient marker of a bow and sling’s maximum range. To ensure that a skirmisher formation could as a whole more accurately hit this extreme range target, weaker shooters could be placed in the front ranks and stronger shooters at the back. If the entire formation deployed in files of 8 men with 2 yards per rank (see below), the rear rankers would be 16 yards further away from the target than the front rankers, enough to significantly cancel out their different shooting ranges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is important to understand that it was not aiming that mattered for a skirmisher, but an accurate estimate of range. His opponent was an enemy line that was impossible to miss if his shot veered off right or left, however the line was relative thin: his arrow or bullet could easily overshoot or fall short.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-84"
    }
  }, [_vm._v("One also needs to keep in mind that skirmisher troops were designed to shoot at a target that was approaching them and which they would eventually have to evade (the one exception was when they were used to stop a cavalry advance by shooting at the horses). They had limited time to loose their missiles and the distance between them and the enemy line was constantly shortening. This imposed a particular restriction ")]), _c('a', {
    attrs: {
      "id": "VPS-85"
    }
  }, [_vm._v("on their style of fighting. If slingers or archers used massed fire – all shooting together over the heads of their comrades without most being able to see the target – then they could only do it accurately at maximum range unless they were highly skilled. This seems counterintuitive, but in fact it is much easier to fire an arrow or sling a bullet to the same point at extreme range than to a much closer point. This is because at extreme range the elevation of a bow or the angle at which a slinger looses his bullet may vary without much variation in the distance his missile travels. At shorter ranges a slight change in elevation or loosing angle results in a significant change to how far the missile goes. Hence a typical archer or slinger could shoot constantly to his maximum range without having to see his target, but he needed to sight anything nearer in order to be sure of hitting it.")])]), _c('a', {
    attrs: {
      "id": "VPS-85"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In consequence a skirmisher line could reliably use massed fire only whilst the enemy was at extreme range (Balearic slingers, armed with three different kinds of sling, could employ massed fire three times during an enemy’s advance). Once the enemy line had advanced within the extreme range window, only the skirmishers in the two or three front rows could continue shooting at their opponents with a reasonable hope of hitting them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were two hypothetical ways all the skirmishers could continue shooting. The first is to rotate the ranks, with two front ranks moving down between the files to the rear after having shot, allowing the ranks behind them to shoot, and eventually returning to the front to shoot again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This system would chime with Vegetius’s remark that ‘the slingers should be taught to whirl the sling but once about the head before they cast the stone.’ For this conveyor belt method of shooting to work to maximum effect each shooter needs to loose his missile as quickly as possible and get out of the way of the next man in the file. The skirmishers have to bombard the enemy line with as many missiles as they could before being obliged to retire through their heavy troops. There is no leisure for time-consuming techniques (see Diagrams 49–52).")])]), _c('a', {
    attrs: {
      "id": "VPS-86"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_86-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 49: Slingers in intermediate order.")])])]), _c('a', {
    attrs: {
      "id": "VPS-87"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_87-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 50: Slingers double files to open order. Front ranks shoot.")])])]), _c('a', {
    attrs: {
      "id": "VPS-88"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_88-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 51: The front-ranks countermarch to the rear.")])])]), _c('a', {
    attrs: {
      "id": "VPS-89"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_89-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 52: The following ranks shoot and retire, to be replaced by the ranks behind them. The cycle continues indefinitely.")])])]), _c('a', {
    attrs: {
      "id": "VPS-90"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The second way is simpler and easier. The front rank shoots then kneels down. The second rank shoots over the heads of the first rank and kneels down. The third rank then shoots over the front two ranks, and so on. When the last rank has shot, all the skirmishers stand, reload their weapons, and recommence the process. This system would also make sense of Vegetius’s injunction that slingers needed to shoot quickly. Each rank had to loose its missile promptly and kneel to allow the next rank to fire, keeping up a rapid and continuous barrage against the approaching enemy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-90"
    }
  }, [_vm._v("There are historical examples of archers firing over kneeling front rank troops. Charles the Bold’s 1473 Burgundian Ordnance")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn28",
      "id": "ch1_28"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("28")])]), _vm._v(" specified that: ‘The pikemen must be made to advance in close formation in front of the said archers, kneel at a sign from them, holding their pikes lowered to the level of a horse’s back so that the archers can fire over the pikemen as if over a wall’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Roman infantry used this tactic in 389 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" against a Gallic army:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gaius Sulpicius, the dictator, marched against them, and is said to have used the following stratagem. He commanded those who were in the front line to discharge their javelins, and immediately crouch low; then the second, third, and fourth lines to discharge theirs, each crouching in turn so that they should not be struck by the spears thrown from the rear; then when the last line had hurled their javelins, all were to rush forward suddenly with a shout and join battle at close quarters. – Appian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gallic History")]), _vm._v(": 1.1.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The problem however is that there is nothing in the sources that suggest these techniques were in general use by skirmishers. It is quite possible and, using Occam’s Razor, probable, that skirmisher foot did not usually go in for this kind of sophistication, being content simply to use all their troops for massed fire at extreme range, then just their front two or three ranks for direct shooting at shorter ranges before retiring through the heavy infantry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Either way, having many ranks of skirmisher foot did not confer any advantage. Massed fire at extreme range would have the same disruptive effect with eight missiles per file as with sixteen, and the area beaten by "), _c('a', {
    attrs: {
      "id": "VPS-91"
    }
  }, [_vm._v("a massed volley would be about the same for sixteen as for eight ranks. At close range of course the extra rearward ranks of skirmishers would be pointless as shooting remains limited to the frontmost ranks. In terms of overall effect having extra ranks of shooters is a waste of manpower, unless one has many more ranks – fifty or a hundred say – in which case the beaten area of massed fire is much deeper, allowing the shooters to disrupt the advancing enemy for a longer period of time. This of course implies much larger armies than those conceived by the manuals.")])]), _c('a', {
    attrs: {
      "id": "VPS-91"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One last disadvantage of too-deep skirmisher lines was the danger of the skirmishers getting charged by the enemy in front of their heavy infantry before they had had the time to retire through them. The fewer men there were that had to pass between the heavy foot files, the quicker the retirement could be completed and the more time the heavies would have to double from open to intermediate spacing before their opponents reached them. This also gave the skirmishers more time to pepper the enemy before falling back, leaving the enemy disorganised at the moment the two heavy infantry lines clashed. Deep lines would have to fall back earlier, allowing the enemy time to recover from the effects of missile fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once behind the enemy line skirmishers could continue to shoot indirectly at the enemy line. Javelinmen would simply throw any javelins they had left over the heads of their own troops into the enemy ranks – they would have enough skill to miss friendly soldiers 16 yards away and hit enemy foot 20 or 30 yards away. Archers and slingers would need to fall back to extreme range to be sure of hitting enemy rather than friend. Archers were probably more accurate at extreme range than slingers – support fire by archers is attested in the sources but no mention is made of slingers in this role.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One final question remains. Asklepiodotus affirms that light troops were sometimes placed within formations of heavy infantry:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes they are incorporated in the phalanx and stationed one beside each man; and this is called insert-position ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("parentaxis")]), _vm._v("], because there is an insertion of different branches of the service, e.g., light infantry with hoplites – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 6.1.")])])]), _c('a', {
    attrs: {
      "id": "VPS-92"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is repeated by Aelian:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Entaxis occurs when it is considered appropriate to insert the light armed infantry into the intervals between each man of the phalanx. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tactics")]), _vm._v(": 30.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why insert the lights between the heavies? There are two possible reasons for this. The first is that the light troops can shoot approaching enemy for a longer period of time before retiring, allowing the heavy infantry to double files at the last moment to receive the enemy attack. This would be effective if the approaching enemy did not have light troops of its own capable of targeting the heavy infantry the skirmishers are placed among.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second reason is ease of battlefield manoeuvring. If lights are to deploy in front of the heavy troops they need to preserve the same frontage as the heavies and ensure their files correspond in positioning to those of the heavies and facilitate a rapid retirement to the rear of the heavy foot. The easiest way to achieve this is for the lights to march with their files inserted between those of the heavy foot. When the heavy formation stops the light troops can continue their advance, stop a short distance ahead of the heavy line, and commence skirmishing. Retiring simply involves the lights turning 180 degrees and moving straight back between the heavy files. Under battlefield conditions the simpler a manoeuvre is to execute the better.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6. Peltasts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Peltasts were a halfway house between light and heavy foot, leaning more to the light side.")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "VPS-92"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-92"
    }
  }, [_vm._v("The peltasts wear the style of armour known as ‘argilos’, which is similar to Macedonian armour only lighter. This type of soldier carries a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pelta")]), _vm._v(" shield, and his spear is much shorter than the Macedonian pike. As such, his armour is in between that of the ‘heavy infantry’ and that of the ‘light infantry’ (being lighter than that of the hoplite but heavier than that of the psiloi) and this has ")]), _c('a', {
    attrs: {
      "id": "VPS-93"
    }
  }, [_vm._v("often caused the peltasts to be confused with the ‘light infantry’ – Aelian: 2.")])]), _c('a', {
    attrs: {
      "id": "VPS-93"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The corps of the peltasts stands in a sense between these two [heavy infantry and skirmisher infantry], for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pelta")]), _vm._v(" is a kind of small, light shield, and their spears are much shorter than those of the hoplites. – Asklepiodotus: 1.2.")])])]), _c('a', {
    attrs: {
      "id": "VPS-93"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Earlier versions of the peltast carried javelins only in addition to their pelta shield. A sword, spear, helmet and body armour were added but with the exception of the shield not every peltast had all of these.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The principal difference between peltasts and skirmisher foot was the ability of peltasts to engage in hand-to-hand combat with cavalry, though on one occasion – at the Trebia – Hannibal’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lonchophoroi")]), _vm._v(" also seem to have engaged the Roman infantry on the flanks and rear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 401 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Cyrus, the younger brother of the ruling Persian king Artaxerxes, raised an army in Anatolia and marched on the Persian capital. The two armies met at Cunaxa on the bank of the Euphrates near modern day Baghdad. In addition to his Persian troops Cyrus had gained the support of 10,400 Greek hoplites and 2,500 peltasts. His Persians numbered 100,000 men. Artaxerxes, according to Zenophon, had assembled a much larger force:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The enemy’s forces were reported to number one million two hundred thousand, with two hundred scythed-chariots, besides which he had six thousand cavalry under Artagerses. These formed the immediate vanguard of the king himself. The royal army was marshalled by four generals or field-marshals, each in command of three hundred thousand men. Their names were Abrocomas, Tissaphernes, Gobryas, and Arbaces. (But of this total not more than nine hundred thousand were engaged in the battle, with one hundred and fifty scythed-chariots; since Abrocomas, on his march from Phoenicia, arrived five days too late for the battle.) Such was the information brought to Cyrus by deserters who came in from the king’s army before the battle, and it was corroborated after the battle by those of the enemy who were taken prisoners. – Xenophon, Anabasis: 7")])])]), _c('a', {
    attrs: {
      "id": "VPS-94"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("These numbers are discounted by contemporary writers. Wikipedia gives an indeterminate number for Cyrus’ Persian infantry – but limited to the tens of thousands – plus 1,600 cavalry and 20 chariots, whilst Artaxerxes is assigned 40,000 men in all. Whether Xenophon’s figures should be discounted in favour of these much smaller estimates is an entire subject in itself and beyond the scope of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After passing over a defensive trench abandoned by Artaxerxes Cyrus was surprised by his brother’s army whilst marching south along the Euphrates in column. He quickly formed his troops into line. The hoplites held the right wing near the Euphrates with 1,000 cavalry plus the 2,500 peltasts between their right flank and the river. The Persians formed up on the left of the Hoplites. Cyrus, with 600 cavalry in the centre between the Greeks and the Persian infantry, was positioned opposite Artaxerxes who likewise took up position in the centre of his own line. Artaxerxes kept most of his 6,000 cavalry with himself, but placed a strong force of horse to the left of his infantry next to the river, opposite the peltasts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the hoplites charged and scattered the Persian cavalry before them, Tissaphernes, leading a body of Persian horse, attacked the peltast flank guard. The peltasts however were ready for them:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The latter [Tissaphernes] had not fled in the first shock of the encounter; he had charged parallel to the line of the Euphrates into the Greek peltasts, and through them. But charge as he might, he did not lay low a single man. On the contrary, the Hellenes separated to let them through, hacking them with their swords and hurling their javelins as they passed. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anabasis")]), _vm._v(": 10.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-94"
    }
  }, [_vm._v("Choosing from the repertoire of manoeuvres available in the manuals, the Peltasts could either have doubled files from intermediate to open order, leaving a 4-foot gap between one file and the next,")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn29",
      "id": "ch1_29"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("29")])]), _vm._v(" or simply bunched the files of their subunits together, leaving wide gaps between them. Horses, naturally reluctant to charge straight into human bodies unless they have to, made for the gaps, passing harmlessly between the peltasts whilst these stabbed at their riders. Persian cavalry were habitually armed with javelins against which the peltasts’ shields were adequate protection.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-95"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Against heavy foot peltasts limited themselves, like light foot, to skirmishing from a distance and retiring out of range if charged. There is no case of peltasts ever voluntarily engaging in frontal melee combat against heavy infantry.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7. Elephants")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As formations go elephants had only one – the line. The elephants’ job was to see off cavalry or disrupt an infantry line, killing a number of foot in the process but more importantly convincing the remainder of the vulnerability of their own formation and its inability to protect them. Elephants were not generally meant to defeat enemy infantry singlehanded since, in the armies covered here, there were usually not enough of them for the job. In this case they worked best in conjunction with their own infantry.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-95"
    }
  }, [_vm._v("At the Battle of the Hydaspes the Indian commander Porus deployed 85 of his elephants in front of his infantry with the remainder in reserve.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn30",
      "id": "ch1_30"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("30")])]), _vm._v(" The elephants each occupied a frontage of 30 yards, stretching in a line about 2.5km long, behind which 30,000 infantry deployed in a line that extended beyond the flanks of the elephants. The elephants looked like they could be bypassed through the wide gaps between them but this in fact was a trap:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("First he placed the elephants in the front, each animal being not less than a plethrum [30 yards] apart, so that they might be extended in the front before the whole of the phalanx of infantry, and produce terror everywhere among Alexander’s cavalry. Besides he thought that none of the enemy would have the audacity to push themselves into the spaces between the elephants, the cavalry being deterred by the fright of their horses; and still less would the infantry do so, it being likely they would be kept off in front by the heavy-armed soldiers falling upon them, and trampled down by the elephants wheeling round against them. – Arrian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Anabasis of Alexander")]), _vm._v(": 5.15.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Alexander avoided the trap by engaging and defeating Porus’ cavalry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were one or two exceptions to this rule. If elephants were numerous enough they could be packed virtually shoulder to shoulder "), _c('a', {
    attrs: {
      "id": "VPS-96"
    }
  }, [_vm._v("and used to crush the enemy infantry single-handed. In 255 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" during the First Punic War a Roman army under the command of Regulus landed in North Africa and beat a Carthaginian army near Adys. The panicked Carthaginians hired Xanthippus, a Spartan general, who arrived with 2,000 Greek mercenaries. Xanthippus laid his hands on every elephant he could find – nearly 100 – and at the battle of Bagradas he deployed them against Regulus in front of a force of Carthaginian citizen spearmen and his mercenaries whilst his cavalry, which far outnumbered the Roman horse, took up position on the flanks.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn31",
      "id": "ch1_31"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To counter the elephants Regulus deployed his infantry much deeper than usual. As will be seen in "), _c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(", a Republican legion typically occupied a frontage of about 200 yards in three lines, each one maniple deep, fronted by velite skirmishers. Here, the Romans deployed ‘many maniples deep’, implying a doubling from one maniple per line to two. This would have halved the frontage of the legion. Since Regulus’s foot numbered 15,000 men, this suggests he had a standard Consular army of two Roman and two Allied legions (usually making up an infantry complement of 20,000 men but his army had suffered losses in the previous battle). With four legions each now occupying 100 yards the Roman foot would have deployed 400 yards wide. According to Polybios the elephants fronted the 10,000 Carthaginian spearmen but not the 2,000 mercenaries next to them, which suggests the elephants covered 5/6 of the Roman line, or about 333 yards – about 3½ yards per elephant, or 10½ feet (see Diagram 53).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_96-001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Diagram 53: The deployment of the Carthaginian elephants at Bagradas.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-97"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("An African forest elephant is about 5 feet wide at its widest point which meant there was about five feet or so between one elephant and the next, sufficient for the animals to move and turn in place (a forest elephant is about 4 yards in length), but not close enough to prevent some Roman legionaries from passing between the elephants where they were promptly dispatched by the Carthaginian spearmen. The Romans facing the Greek mercenaries defeated them and were able to leave the battlefield as the only survivors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In most other battles elephants deployed with a frontage of 10 to 50 yards per elephant. Skirmishers accompanied them to prevent enemy missile troops from targeting them, but it is still a mystery as to why the enemy heavy foot could not simply surround each elephant and hamstring or kill it. It is possible they tried exactly this, with the elephants turning right and left in rage to keep them at bay, killing several in the process. It is also possible that enemy infantry had no choice but to keep their ranks when attacked by elephants, as breaking formation to surround the beasts would leave them disrupted and vulnerable to an attack by enemy foot. One can hypothesise that elephants were used against enemy infantry to achieve precisely this effect.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8. Chariots")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-97"
    }
  }, [_vm._v("Of all the troop types, the manuals have the least to say about chariot formations, merely giving their unit breakdown without any description of how they were organised and used in battle. Pictorial representations of chariots in battle from Egyptian reliefs are problematic as the images are stylised and two-dimensional, giving little idea of depth and hence the distance between chariots, but the relief of the Battle of Kadesh on the north wall the Great Temple of Abou seems to show the chariots of each opposing army organised into a loose line with some distance between one chariot and the next. It is highly unlikely that opposing chariots physically ploughed into each other as horses will not normally charge into contact with other horses, hence chariot vs chariot combat probably consisted of the two opposing chariot lines stopping a short distance from each other whilst their crews shot arrows, threw javelins or even dismounted to engage enemy charioteers in hand-to-hand ")]), _c('a', {
    attrs: {
      "id": "VPS-98"
    }
  }, [_vm._v("combat, this kind of fighting continuing until one side eventually broke. The space between chariots would enable a charioteer to turn his vehicle")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn32",
      "id": "ch1_32"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])]), _vm._v(" without colliding with his neighbours and withdraw from the engagement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chariots however were not meant just to engage other chariots. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(" of Kauţilya, an Indian treatise on statecraft, economic policy and military strategy, composed between the 3rd and 2nd centuries bc, lists the uses of chariots. These are heavy chariots with 5 horses to each car, but what is said about them probably applies to similar chariots of the Fertile Crescent.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Protection of the army; repelling the attack made by all the four constituents of the enemy’s army [infantry, cavalry, elephants, chariots]; seizing and abandoning [positions] during the time of battle; gathering a dispersed army; breaking the compact array of the enemy’s army; frightening it; magnificence; and fearful noise – these constitute the work of chariots. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(": 10.4.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Running against; running round; running beyond; running back; disturbing the enemy’s halt; gathering the troops; curving, circling, miscellaneous operations; removal of the rear; pursuit of the line from the front, flanks and rear; protection of the broken army; and falling upon the broken army – these are the forms of waging war with horses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same varieties with the exception of [what is called] miscellaneous operations; the destruction of the four constituents of the army, either single or combined; the dispersion of the flanks, wings and front trampling down; and attacking the army when it is asleep – these are the varieties of waging war with elephants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same varieties with the exception of disturbing the enemy’s halt; running against; running back; and fighting from where it stands on its own ground – these are the varieties of waging war with chariots. – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(": 10.5.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So besides manoeuvring on the battlefield, exerting psychological intimidation, pursuing broken enemies and rounding up their own forces, chariots were also expected to engage all troop types and break "), _c('a', {
    attrs: {
      "id": "VPS-99"
    }
  }, [_vm._v("‘the compact array of the enemy’s army’. To this end the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(" recommends deploying chariots in several lines each as compact as possible.")])]), _c('a', {
    attrs: {
      "id": "VPS-99"
    }
  }, [_c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The infantry should be arrayed such that the space between any two men is a sama [about 28cm, in between intermediate and close order]; cavalry with three samas; chariots with four samas [i.e. roughly a yard] – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthaśāstra")]), _vm._v(": 10.5.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is as close as chariots in a line can get without fouling each other. The space between one line and the next however is quite generous.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A bow means five aratnis [= 240cm]. Archers should be stationed at the distance of five bows [from one line to another]; the cavalry at the distance of three bows; and chariots or elephants at the distance of five bows [about 12m] – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ibid")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chariots in lines this compact cannot wheel without hitting their neighbours, and once committed must move forwards. They were thus meant to plough straight into enemy infantry, to which the ‘compact array’ implicitly refers. Could they do this? Will horses charge directly into a solid line of foot?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-99"
    }
  }, [_vm._v("The answer is most certainly yes.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn33",
      "id": "ch1_33"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A galloping horse has tremendous kinetic energy and is quite capable of knocking down several adjacent men in succession."), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_fn34",
      "id": "ch1_34"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])]), _vm._v(" Without experimentation (with possibly fatal results for the participants) it is impossible to know just how many men a horse at full gallop "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _vm._v(" knock flat, but there is an equation that gives some idea of the forces involved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How much energy is needed to knock over a standing man? Assume a man weighing 70kg is hit around his midriff, about a metre above the ground, and that the man is standing with his feet a yard apart. The equation is:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("mgl = Fh")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("where "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("m")]), _vm._v(" is the mass of the man (70 kg);")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("g")]), _vm._v(" is a constant: 9.8;")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-100"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("l")]), _vm._v(" is the distance from the man’s tipping point to his centre of gravity,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("assumed to be half the width of his spread feet or 0.45m;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F")]), _vm._v(" is the force in Newtons;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("h")]), _vm._v(" is the height at which the man is hit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The equation becomes:")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("70 x 9.8 x 0.45 = "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("F")]), _vm._v(" x "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F")]), _vm._v(" = 308.7 Newtons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The next question is to determine how much force is needed to stop a charging horse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A horse in Antiquity was smaller than a horse today. Horses in Roman times were 11–12 hands high, weighed in the region of 250kg and could probably get up a speed of 40km/h.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First we need to work out how much kinetic energy is in a galloping horse. The equation is:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Kinetic Energy = 0·5 x 250kg x velocity"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "equ"
  }, [_vm._v("= 0·5 x 250 x 40km/h"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "equ"
  }, [_vm._v("= 0·5 x 250 x 11.11m/s"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "equ"
  }, [_vm._v("= 0·5 x 250 x 123.45")]), _vm._v(" "), _c('p', {
    staticClass: "equ"
  }, [_vm._v("= 15,432 Joules")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next, and this is the tricky part, we need to factor in the distance the horse must traverse whilst hitting the men, as the more time the horse spends ploughing through infantry the less force is required to bring it to a halt. Presuming that each rank occupies a depth of one yard, the equation is as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("J = Fm")]), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("J")]), _vm._v(" is the kinetic energy in Joules;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F")]), _vm._v(" is the force in Newtons;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("m")]), _vm._v(" is the number of ranks, each a yard in depth.")])]), _c('a', {
    attrs: {
      "id": "VPS-101"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Which gives:")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("15,432 = 308.7 x "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("m")]), _c('sup', {
    staticClass: "bold sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("15,432 / 308.7 = "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("m")]), _c('sup', {
    staticClass: "bold sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("49.99 = m"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("7.07 = "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("m")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The horse will plough through seven ranks of infantry before being brought to a halt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is probably far too conservative an estimate as it assumes that the infantryman’s body will be slowing down the horse for the full distance of a yard, unlikely as the man is knocked down almost immediately and no longer exerts any drag on the horse’s progress. It does however give an idea of the impressive power of a charging horse and explains how Roman cavalry could pierce right through a line of enemy infantry in all likelihood at least eight ranks deep and probably more. It also suggests why infantry lines were rarely less than eight men deep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Packing the horses together into a single compact unit – the chariot – made them even more potent against infantry. Unlike cavalry, horses harnessed to a chariot cannot shy away from an obstacle in front of them. Two horses yoked together would tend to go in opposite directions, cancelling each other out, and in a four-horse arrangement the two central horses would not be able to change direction at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chariot then was the ultimate infantry battering ram and ruled the Ancient battlefield for centuries, only losing its supremacy as infantry gradually learned how to neutralise its fearsome inertia by deploying deep, by compacting ranks together to make the individual men harder to knock over, by opening gaps to let the chariots through, and finally by digging trenches before the infantry lines as the Romans did against Mithridates. When horse breeds became larger cavalry grew in importance, able to plough through unprepared infantry in the same ways chariots did and capable of traversing terrain unsuitable for chariot wheels. By the time the legions ruled the Mediterranean the day of the chariot was done.")])]), _c('a', {
    attrs: {
      "id": "VPS-102"
    }
  }, [_c('h3', {
    staticClass: "sub_h",
    attrs: {
      "id": "sub1_9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])]), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "VPS-102"
    }
  }, [_c('span', {
    staticClass: "notec"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_1",
      "id": "ch1_fn1"
    }
  }, [_vm._v("1.")]), _vm._v(" Curtius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Alexander")]), _vm._v(": 8.14.40.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_2",
      "id": "ch1_fn2"
    }
  }, [_vm._v("2.")])]), _vm._v(" Asklepiodotus: 2.2; Aelian: 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_3",
      "id": "ch1_fn3"
    }
  }, [_vm._v("3.")])]), _vm._v(" Asklepiodotus:2.3; Aelian: 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_4",
      "id": "ch1_fn4"
    }
  }, [_vm._v("4.")])]), _vm._v(" Asklepiodotus:2.3; Aelian: 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_5",
      "id": "ch1_fn5"
    }
  }, [_vm._v("5.")])]), _vm._v(" Asklepiodotus: 2.7; Aelian: 8.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_6",
      "id": "ch1_fn6"
    }
  }, [_vm._v("6.")])]), _vm._v(" Polybios, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 3.113.2.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_7",
      "id": "ch1_fn7"
    }
  }, [_vm._v("7.")])]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://romanarmy.info/march2_basics/march_basics.html",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://romanarmy.info/march2_basics/march_basics.html")])])])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_8",
      "id": "ch1_fn8"
    }
  }, [_vm._v("8.")])]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://romanarmy.info/march4_baggage/march_baggage.html",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://romanarmy.info/march4_baggage/march_baggage.html")])])])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "notec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_9",
      "id": "ch1_fn9"
    }
  }, [_vm._v("9.")])]), _vm._v(" Asklepiodotus: 9.12.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_10",
      "id": "ch1_fn10"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://romanarmy.info/march7_days/march_days.html",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://romanarmy.info/march7_days/march_days.html")])])])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_11",
      "id": "ch1_fn11"
    }
  }, [_vm._v("11.")])]), _vm._v(" Journal of Cross-Cultural Psychology 2017, Vol. 48(4) 577–592.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_12",
      "id": "ch1_fn12"
    }
  }, [_vm._v("12.")])]), _vm._v(" Asklepiodotus: 5.1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_13",
      "id": "ch1_fn13"
    }
  }, [_vm._v("13.")])]), _vm._v(" See discussion on the length of a cubit in Chapter 3: 3. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Phalangite’s Panoply")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_14",
      "id": "ch1_fn14"
    }
  }, [_vm._v("14.")])]), _vm._v(" See discussion on the phalangite shield in Chapter 3: 3. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Phalangite’s Panoply")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_15",
      "id": "ch1_fn15"
    }
  }, [_vm._v("15.")])]), _vm._v(" See discussion on othismos in Chapter 2: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("7. The Phalanx in Combat")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_16",
      "id": "ch1_fn16"
    }
  }, [_vm._v("16.")])]), _vm._v(" Asklepiodotus: 10.13–15; Arrian: 23; Aelian: 26.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_17",
      "id": "ch1_fn17"
    }
  }, [_vm._v("17.")])]), _vm._v(" Aelian: 28; Arrian: 25.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_18",
      "id": "ch1_fn18"
    }
  }, [_vm._v("18.")])]), _vm._v(" Asklepiodotus: 12.9: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("If the centre must assume the compact position, we shall command the right wing to left face and the left wing to right face, then to advance to the navel of the phalanx, to face to the front, and to advance the rear ranks, and we shall have the desired formation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_19",
      "id": "ch1_fn19"
    }
  }, [_vm._v("19.")])]), _vm._v(" Aelian: 28.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_20",
      "id": "ch1_fn20"
    }
  }, [_vm._v("20.")])]), _vm._v(" Aelian: 28; Arrian: 25")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_21",
      "id": "ch1_fn21"
    }
  }, [_vm._v("21.")])]), _vm._v(" Asklepiodotus: 10.18.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_22",
      "id": "ch1_fn22"
    }
  }, [_vm._v("22.")])]), _vm._v(" Aelian: 28.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_23",
      "id": "ch1_fn23"
    }
  }, [_vm._v("23.")])]), _vm._v(" Asklepiodotus: 6.1; Aelian: 30; Arrian: 26.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_24",
      "id": "ch1_fn24"
    }
  }, [_vm._v("24.")])]), _vm._v(" Asklepiodotus: 6.1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_25",
      "id": "ch1_fn25"
    }
  }, [_vm._v("25.")])]), _vm._v(" Arrian: 36, 39, 40.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_26",
      "id": "ch1_fn26"
    }
  }, [_vm._v("26.")])]), _vm._v(" Asklepiodotus: 7.5; Aelian: 19.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_27",
      "id": "ch1_fn27"
    }
  }, [_vm._v("27.")])]), _vm._v(" ‘Recreating the Ancient Greek Javelin Throw: How Far Was the Javelin Thrown?’ by Steven Ross Murray, William A. Sands, and Douglas A. O’Roark, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nikephoros")]), _vm._v(", Volume 25.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_28",
      "id": "ch1_fn28"
    }
  }, [_vm._v("28.")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Charles the Bold: The Last Valois Duke of Burgundy")]), _vm._v(", by Richard Vaughan. Page 210")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_29",
      "id": "ch1_fn29"
    }
  }, [_vm._v("29.")])]), _vm._v(" Closing up their syntagmas to form close-order blocks with gaps between each block for the horses to pass would probably have left them too cramped to effectively employ their weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_30",
      "id": "ch1_fn30"
    }
  }, [_vm._v("30.")])]), _vm._v(" According to Arrian Porus led 200 elephants against Alexander and deployed them in a single line with each elephant 30 yards apart ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anabasis")]), _vm._v(": 5.15.4). His 30,000 infantry deployed behind the elephants in a ‘dense "), _c('a', {
    attrs: {
      "id": "VPS-103"
    }
  }, [_vm._v("phalanx’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anabasis")]), _vm._v(": 5.16.2) that extended beyond the flanks of the elephant line. If all 200 elephants had deployed in this manner, their line would be 6km long and the infantry line longer. The infantry would be at best 5 ranks deep if in intermediate order, which hardly corresponds to the ‘dense phalanx’ [πυκνός φάλαγξ] described by Arrian. Curtius affirms that Porus initially deployed at the Hydaspes with 85 elephants in front of 30,000 infantry ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Alexander")]), _vm._v(": 8.3.6). Presuming he duplicated this deployment after Alexander had crossed the river (Arrian affirms Porus had the same number of infantry at the main battle), the elephant line would be 2.5km long and the infantry line behind it would be about 12 men deep. This was still a very long line and Curtius describes Porus losing control of his ‘scattered forces’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Alexander")]), _vm._v(": 8.14.22). The best way to resolve these accounts seems to be to accept that Porus kept most of his elephants in reserve during the battle, deploying as many as could create a line of manageable length.")])]), _c('a', {
    attrs: {
      "id": "VPS-103"
    }
  }), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "VPS-103"
    }
  }, [_c('span', {
    staticClass: "noted"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_31",
      "id": "ch1_fn31"
    }
  }, [_vm._v("31.")]), _vm._v(" Polybios, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 1.32–33.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_32",
      "id": "ch1_fn32"
    }
  }, [_vm._v("32.")])]), _vm._v(" A really tight turn by a chariot could be achieved by a side pass movement of the horse, combined with the horse turning towards the direction it is moving. This would enable the chariot to wheel virtually on a dime. It would require well-trained horses. Wheels of chariots found in Tutankamen’s tomb rotate independently of each other, facilitating tight turns of this nature.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_33",
      "id": "ch1_fn33"
    }
  }, [_vm._v("33.")])]), _vm._v(" Republican Roman cavalry routinely charged through formed enemy heavy infantry: Livy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histories")]), _vm._v(": 3.70; 8.30.6.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "noted"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch1_34",
      "id": "ch1_fn34"
    }
  }, [_vm._v("34.")])]), _vm._v(" Several examples of this:")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=rvSS9MaVWlg",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=rvSS9MaVWlg")])])])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=_PbVIl7DRDo",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=_PbVIl7DRDo")])])])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=D-0vzjTvesw",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.youtube.com/watch?v=D-0vzjTvesw")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55243bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_Chapter_1.vue
// module id = 75
// module chunks = 0